import HELPER from '@/app/utils/HELPER';
import isBlank from '@/app/utils/isBlank';
import getParameterByName from '@/app/utils/getParameterByName';
import api from '@/app/endpoints.js';
import { GET, POST, PUT } from '@/app/api';
import store from '@/app/store/store';
import config from '@/app/editor/config';
import atom from '@/app/editor/iframe/atom';
import InteractionPanel from '@/app/editor/sidebar/interactions';
import { $socket, offPublish, onPublish } from '@/app/socket';
import { getDynamicProduct, isInIframe, postMessageToParent } from '@/app/utils/helpers.ts';
import FlowActionsPanel from '@/app/editor/sidebar/actions';
import { initRegisterAction } from '@/app/editor/sidebar/actions/actions.config';
import { getStyleFromActionItems } from '@/app/editor/sidebar/actions/actions.utils';
import {
  templateArticlePage,
  templateCollectionPage,
  templateGemMeterProgressBar,
  templateHomePage,
  templateProductPage,
  templateSubpage,
  warningConfirmPassword,
} from './templates/publish';
import { liveView } from './templates/view';
import { fetchTemplateCampaign, waitForTemplateCampaign } from '@/modules/ab-testing/stores/gemX';
import { checkKeyValid } from '@/app/utils/checkRoleApply';
import storeX, { app } from '@/store';
import { mutations } from '@modules/libraries/store/types';
import { showHeaderFooterPlaceholderOnGryffBody } from '@/app/utils/headerFooterPlaceholder';
import { EDITOR_EVENT } from '@/app/editor/config/constants/trackEventIds';
import { base, elementTypes, moduleTypes, rowTypes } from '@/app/editor/sidebar/constant';
import { arrayFilter } from '@/app/utils/nativeArray';
import { applyPreset } from '@/utils/apply-preset';
import { insertInstalledFontsWhenSavingPage } from '@/app/utils/manageInstalledFont';
import emitter from '@/emitter';
import {
  useGemMeter,
  emitTrackCompleteRateEvent,
  MutationTypes,
  isLandingPage,
  ACTIVE_CLASSES,
  CHECK_LIST,
} from '@/modules/gem-meter';
import { FEATURE_TYPES, PAGE_TYPES, PLAN_NAMES } from '@modules/common';
import { getLatestProduct, changeAllAutoValueToLatestId } from '@/app/utils/assignedProductHelper';
import { handleAddToLibrary } from '../sidebar/utils/validateAddToLibrary';
import __cloneDeep from 'lodash.clonedeep';
import { disableNavBarAction, enableNavBarAction } from '@/modules/unpublish/utils/dom-helper';
import customStore from '@/app/store/store';
import { GEM_METER_TRIGGER_EVENT } from '@/modules/gem-meter/constants';
import * as Sentry from '@sentry/vue';

const PAGE_ACTIONS = {
  PUBLISH: 'publish',
  SAVE: 'save',
};

(function (jQuery) {
  jQuery.gryffEditor = function (element, options) {
    const defaults = {
      author: 'SEAL Commerce | Shopify experts',
      email: 'chris@sealcommerce.asia',
    };

    this.settings = {};
    let $element = jQuery(element);
    const _this = this;
    let _isDragging = false;
    // đếm thời gian khi nhấn nút publish
    let publishCounter = 0;

    /* Editor */
    let $gfLeftSideBar = jQuery('#gfLeftSideBar');
    const $divTopBar = jQuery('#divTopBar');
    const $divContentHidden = jQuery('#divContentHidden');
    const $divContentBk = jQuery('#divContentBk');
    let $gfResTool = jQuery('#gfResTool');
    let $notifiBar = jQuery('#notifiBar').notifiBar();

    /* Iframe */
    const $gfFrame = jQuery('#gfFrame');
    const $gfVisualFrame = jQuery('#gfVisualFrame');
    const $gryffEditor = $gfFrame.contents().find('.gryffeditor').first();
    const $gryffBody = $gfFrame.contents().find('body').first();
    let mode = $gfFrame.contents().find('.gryffeditor').hasClass('editing') ? 'dev' : 'production';
    let messageSaveSuccess = {
      message: 'Data saved Successfully.',
      duration: 3000,
    };

    this._isBlank = isBlank;
    this._getParameterByName = getParameterByName;

    /* Data */
    const gfFrameData = $gfFrame.data('gfframe');

    // ham khoi tao init()
    this.init = function () {
      this.settings = jQuery.extend({}, defaults, options);
      window.$gfPlaceHolders = [];
      window.$gfVSPlaceHolders = [];
      window._placeHolders = [];
      window.blockOBTabSetting = false;
      //add register action
      try {
        initRegisterAction();
      } catch (error) {
        console.warn('Custom Actions Error', error);
      }

      if (checkKeyValid('blockStyleAnimationCarousel')) {
        // In the `Carousel` style, there is a part of CSS that consumes CPU,
        // so it needs to be blocked in the editor
        this.blockStyleAnimationCarousel();
      }

      // Auto remove a#link outside of editor
      $gryffBody.find('a').each(function () {
        if (jQuery(this).closest('.gryffeditor').length === 0) {
          jQuery(this).attr('href', 'javascript:void(0);');
        }
      });

      // Remove all opacity
      $gryffBody.find('.element-wrap, .module-wrap, .gf_row').css('opacity', '');

      // Tạo tag div để chứa css cho các element
      if ($element.closest('body').find('#' + elementTypes._elementStyleContainer).length === 0) {
        jQuery(`<div id="${elementTypes._elementStyleContainer}"></div>`).insertAfter($element);
      }

      // Tạo tag div để chứa css cho các module
      if ($element.closest('body').find('#' + moduleTypes._moduleStyleContainer).length === 0) {
        jQuery(`<div id="${moduleTypes._moduleStyleContainer}"></div>`).insertAfter($element);
      }

      // Tạo tag div để chứa css cho các row
      if ($element.closest('body').find('#' + rowTypes._rowStyleContainer).length === 0) {
        jQuery(`<div id="${rowTypes._rowStyleContainer}"></div>`).insertAfter($element);
      }

      // Tạo tag div để chứa css cho các column
      if ($element.closest('body').find('#' + rowTypes._columnStyleContainer).length === 0) {
        jQuery(`<div id="${rowTypes._columnStyleContainer}"></div>`).insertAfter($element);
      }

      // Tạo tag div để chứa interactions
      if ($element.closest('body').find('#' + base._interactions).length === 0) {
        jQuery(`<div id="${base._interactions}" style="display:none"></div>`).insertAfter($element);
      }

      // Tạo tag div để chứa action
      if ($element.closest('body').find('#' + base._actions).length === 0) {
        jQuery(`<div id="${base._actions}" style="display:none"></div>`).insertAfter($element);
      }
      // Before setContentBkToStore => RUN Modify Style
      const preset = app.$store.getters['sidebar/getPresetByPagePresetId'];
      if (preset && Object.keys(preset).length) {
        applyPreset(preset, null);
      } else {
        store.onChange('isRenderFirstPage', function (preset) {
          store.setValue('currentPresetInPage', preset);
          applyPreset(preset, null);
        });
      }

      // Tạo tag div để chứa action-style
      if ($element.closest('body').find('#' + base._actionsStyle).length === 0) {
        jQuery(`<div id="${base._actionsStyle}"></div>`).insertAfter($element);
      }

      // Tạo tag div để chứa script cho các module
      if ($element.closest('body').find('#' + moduleTypes._moduleScriptContainer).length === 0) {
        jQuery(`<div id="${moduleTypes._moduleScriptContainer}"></div>`).insertAfter($element);
      }

      // Set data of divContenBk -> Store
      // Run only one before render page
      HELPER.setContentBkToStore();

      if ($divContentHidden.length === 0) {
        jQuery('body').append('<div id="divContentHidden"></div>');
      }

      app.$store.commit('page/SET_DEFAULT_LAZY_LOADING', gfFrameData.getPageLazyload());
      const newValue = {
        title: gfFrameData.getPageTitle(),
        handle: gfFrameData.getPageHandle(),
        description: gfFrameData.getPageMeta(),
      };
      app.$store.commit('page/SET_DEFAULT_GENERAL_PAGE_SETTING', {
        newValue,
        pageType: gfFrameData.getPageType(),
        pageGID: gfFrameData.getPageId(),
      });

      // check password
      const shop = gfFrameData.getShopDomain();
      if (shop !== '') {
        if (checkKeyValid('passwordModal')) {
          if ($gryffBody.find('.gf_require-password').length > 0) {
            showHeaderFooterPlaceholderOnGryffBody($gryffBody);
            app.$store.commit('app/OPEN_GET_SOURCE_MODAL', 'password');
          } else if ($gryffBody.find('.gf_error-get-source').length > 0) {
            const errorJsonString = $gryffBody.find('.gf_error-get-source').html().trim();
            const errorJson = JSON.parse(errorJsonString);

            showHeaderFooterPlaceholderOnGryffBody($gryffBody);

            if (errorJson.error && errorJson.error === 'invalidDomain') {
              app.$store.commit('app/OPEN_GET_SOURCE_MODAL', 'wrong-domain');
            } else {
              app.$store.commit('app/OPEN_GET_SOURCE_MODAL', 'default');
            }
          }
        } else {
          // if (app.$store.state['app']?.shopInfo?.passwordEnabled) {
          //   app.$store.state['app'].enablePassword = true;
          // }

          emitter.on('toggle-password', (payload) => {
            const passwordLink = 'https://' + shop + '/admin/online_store/preferences?tutorial=unlock';
            let alert = `
              <p class="text-left !ml-2 !pt-[2px] text-light-mode-hight-contrast !mt-0 !mb-0 !leading-[22px]">
                    You can find your store password in
                  <a class="text-primary-300 !botder-none font-semibold" target="_blank" href="${passwordLink}">Shopify Store Preferences.
                  </a>
                  <p class="!ml-2 !mt-0 !mb-0 text-light-mode-hight-contrast">
                  We only access to your theme style. Learn more about our
                  <a class="text-primary-300 !botder-none font-semibold" target="_blank" href="https://gempages.net/pages/privacy">Privacy Policy.
                  </a>
                </p>
                </p>
              `;

            if (payload?.source === 'public') {
              alert = `
                 <p class="!ml-2 !mt-0 !mb-0 text-light-mode-hight-contrast text-left !leading-[22px]">You can find your store password in
                  <a class="text-primary-300 !botder-none font-semibold" target="_blank" href="${passwordLink}">Shopify Store Preferences
                  </a>
                </p>
                <p class="!ml-2 !mt-0 !mb-0 text-light-mode-hight-contrast">We only access to your theme style. Learn more about our
                  <a class="text-primary-300 !botder-none font-semibold" target="_blank" href="https://gempages.net/pages/privacy">Privacy Policy.
                  </a>
                </p>
                `;
            }

            if (payload?.source === 'gs-create-preset') {
              alert = `
                 <p class="!ml-2 !mt-0 !mb-0 text-light-mode-hight-contrast text-left !leading-[22px]">
                 We need to access to your Shopify store to create Global style preset from Live Theme. You can find your store password in
                  <a class="text-primary-300 !botder-none font-semibold" target="_blank" href="${passwordLink}">Shopify Store Preferences.
                  </a>
                </p>
                <p class="!text-left !ml-2 !mt-0 !mb-0 text-light-mode-hight-contrast">
                    We only access to your theme style. Learn more about our
                  <a class="text-primary-300 !botder-none font-semibold" target="_blank" href="https://gempages.net/pages/privacy">Privacy Policy.
                  </a>
                </p>
                `;
            }

            const template = `
                <div class="ui-preview-container">
                <div class="md-password preview-right">
                <div class="h-[56px] flex items-center border-b border-b-light-400 flex justify-between">
                <h4 class="text-base !pl-4 text-light-mode-high-contrast font-medium">Access to Shopify store password</h4>
                <div class="flex items-center justify-center cursor-pointer w-[32px] h-[32px] hover:bg-[#E5E5E5] close !mr-3"><img src="/editor/static/icons/close-modal.svg" /></div>
                </div>
                <div class="flex items-start !mt-4 !mx-4 !bg-primary-100 rounded-sm">
                <img class="!ml-[17.5px] pt-[18.5px]" src="/editor/static/icons/info-alert.svg" />
                <div class="noti-desc !pb-4 !pt-4">
                ${alert}
                </p>
                </div>
                </div>
                <div class="!mx-4 !mt-5 text-light-mode-low-contrast">Your Shopify store password</div>
                <div class="!mx-4 !mb-4"><input class="input-password" type="text" name="password" placeholder="Enter password" /></div>
                <div id="error-message" class="!mt-[10px] !ml-[17.5px] !mb-4 flex error hidden w-[calc(100%_-_35px)]">
                <div class="flex items-center justify-center h-[22px] mt-[1px]">
                <img class="w-[20px] h-[20px] min-w-[20px]" src="/editor/static/icons/error-alert.svg" />
                </div>
                <span class="!ml-2 message !text-red-300"></span>
                </div>
                <div class="h-[72px] border-t border-t-light-400 flex items-center justify-end !pr-3">
                <button class="hover:bg-[#E5E5E5] h-10 bg-white !border !border-dark-100 !mr-2 rounded-sm text-[#212121] font-medium flex items-center !px-6" data-action="cancel">Cancel</button>
                <button class="h-10 bg-light-300 text-light-mode-disabled !border-none flex items-center font-medium rounded-sm !px-6 pointer-none" data-action="yes">
                Save
                </button>
                </div>
                </div>
                </div>`;

            const $activeModal = jQuery('<div/>').appendTo($divContentHidden);
            $activeModal.gfModalNew({
              header: '',
              footer: '',
              width: 600,
              // 'height': 469,
              center: true,
              overlayClick: true,
              bg: 'rgba(0,0,0,0.7)',
              // 'background': '#fff',
              // 'contentClass': 'new-ui-preview', // help me named this
              minimizedHeader: true,
              onContent: function ($content) {
                $content.html(template);
              },
            });

            $activeModal.data('gfmodalnew').onShow();
            $activeModal
              .find('.input-password')
              .off('keyup')
              .on('keyup', function (el) {
                const value = el.target.value;
                if (value === '') {
                  $activeModal
                    .find('button[data-action="yes"]')
                    .addClass('bg-light-300 !text-light-mode-disabled pointer-none');
                  $activeModal.find('button[data-action="yes"]').removeClass('bg-primary-300 !text-white');
                } else {
                  $activeModal
                    .find('button[data-action="yes"]')
                    .removeClass('bg-light-300 !text-light-mode-disabled pointer-none');
                  $activeModal
                    .find('button[data-action="yes"]')
                    .addClass('hover:bg-[#6385FF] bg-primary-300 !text-white');
                }
              });

            $activeModal
              .find('.close')
              .off('click')
              .on('click', function () {
                $activeModal.data('gfmodalnew').onClose();
                emitter.emit('close:modal-password');
                return false;
              });

            $activeModal
              .find('button[data-action="yes"]')
              .off()
              .on('click', function (e) {
                const $button = jQuery(this);
                $activeModal.find('#error-message').addClass('hidden');
                $activeModal.find('span.message').html('');

                $activeModal.find('button[data-action="yes"]').removeClass('bg-light-300 !text-light-mode-disabled');
                $activeModal
                  .find('button[data-action="yes"]')
                  .addClass('hover:bg-[#6385FF] bg-primary-300 !text-white');

                const buttonText = $button.text();
                $button.html(`<img class="animate-spin !mr-2" src="/editor/static/icons/spin.svg" />Saving your work`);

                const password = $activeModal.find('input[name="password"]').removeClass('error').val();
                if (jQuery.trim(password) !== '') {
                  const data = {
                    shop: shop,
                    password: password,
                  };

                  const beforeSend = (xhr) => {
                    xhr.setRequestHeader('X-CSRF-Token', jQuery('meta[name="csrf-token"]').attr('content'));
                  };
                  POST('/api/shop/checkPassword.html', data, undefined, undefined, undefined, beforeSend)
                    .then((res) => {
                      const jsonData = res.data;
                      if (jsonData && jsonData['status'] === 'success') {
                        app.$store.state['app'].enablePassword = false;
                        messageSaveSuccess = {
                          message: `Data saved successfully. <a class="text-blue-300 font-semibold cursor-pointer" onclick="location.reload()">Reload page</a> to apply Shopify theme style.`,
                          duration: 7000,
                        };

                        if (typeof window?.Intercom === 'function') {
                          window?.Intercom('update', { vertical_padding: 20 });
                        }

                        $divTopBar.find('.gf-save-btn ').trigger('click');
                        $activeModal.data('gfmodalnew').onClose();
                        emitter.emit('close:modal-password');

                        setTimeout(function () {
                          $button.text('Reloading');
                        }, 300);
                      } else {
                        $activeModal
                          .find('span.message')
                          .html('Wrong password! You can find it in Shopify Store Preferences.');
                        $activeModal.find('input[name="password"]').addClass('error');
                        setTimeout(function () {
                          $button.text(buttonText);
                        }, 300);
                      }
                    })
                    .catch((error) => {
                      $activeModal.find('.error').removeClass('hidden');
                      if (error.xhr.status === 500 || error.xhr.status === 0) {
                        $activeModal.find('span.message')
                          .html(`Error connecting to Shopify server. This is a problem on the server side, not on
                            our end. If you continue to experience any issues, we recommend ​clearing your
                            cache before logging in to Shopify or contacting their support.`);
                      } else {
                        $activeModal
                          .find('span.message')
                          .html(`Wrong password. Please check your password at Shopify Store Preferences`);
                      }

                      $activeModal.find('input[name="password"]').addClass('error');
                      setTimeout(function () {
                        $button.text(buttonText);
                      }, 300);
                    });
                } else {
                  $activeModal.find('.error').removeClass('hidden');
                  $activeModal.find('input[name="password"]').addClass('error');
                  $activeModal
                    .find('span.message')
                    .html(`Wrong password. Please check your password at Shopify Store Preferences`);
                  setTimeout(function () {
                    $button.text(buttonText);
                  }, 300);
                }

                return false;
              });
            $activeModal
              .find('button[data-action="cancel"]')
              .off()
              .on('click', function (e) {
                $activeModal.data('gfmodalnew').onClose();
                emitter.emit('close:modal-password');
                return false;
              });
          });
        }
      }

      $gfLeftSideBar = jQuery('#gfLeftSideBar');
      $gfLeftSideBar.gfLeftSideBar();

      jQuery('#pageInfo .page-name').each(function (index, item) {
        const $item = $(item);
        $item.gfTooltipsNew({
          postion: 'bottom',
          desc: $item.text(),
        });

        store.onChange('change-page-name', function (newPageName) {
          $item.data('gftooltipsnew').setDesc(newPageName);
        });
      });

      window.__gpAutoFixTemplate = true;
      // ===== GemMeter Feature ===== //
      if (isLandingPage()) {
        window.__countElement = $element.find('[data-key]').length;
        emitter.emit('editor:start-counter-mer', true);
      }
      // =========================== //

      $gfLeftSideBar.data('gfleftsidebar').loadSnippets();
      this.loadLiquid();

      $gfResTool = $divTopBar.find('#gfResTool').gfResTool();
      $notifiBar = jQuery('#notifiBar').notifiBar();

      $gryffBody.gfTools();
      $element.gfTextEditor();
      $element.gfQuickBar();

      $element.gfHistory();
      $element.gfCount();

      const $toolsTipTest = jQuery('.test-tools-tip');
      $toolsTipTest.gfTooltipsNew({
        postion: 'bottom',
        width: '350px',
      });

      // FONTS
      _this.initPageFonts();

      const $gfCheckBrowser = jQuery('#checkBrowser');
      $gfCheckBrowser.gfCheckBrowser();

      $gryffBody.gfContextMenu({
        onItemClicked: function (key, $target, parentId, itemClicked) {
          key = key.toUpperCase();
          const $itemClicked = itemClicked ? jQuery(itemClicked) : undefined;
          if ($itemClicked) {
            var dataSections = ($itemClicked.data('sections') || '').split('|');
          }

          if (parentId !== '') {
            let $parent = $gryffBody.find('#' + parentId);
            if ($parent.length > 0) {
              if ($parent.data('gfmodule') !== undefined) {
                $parent.data('gfmodule').openModuleSettings();
              } else if ($parent.data('gfrow') !== undefined) {
                $parent.data('gfrow').openRowSettings();
              } else if ($parent.parent().data('gfrow') !== undefined) {
                $parent = $parent.parent();
                $parent.data('gfrow').openRowSettings();
              } else if ($parent.data('gfelement') !== undefined) {
                $parent.data('gfelement').openElementSettings();
              }

              $gryffEditor.parents('html, body').animate(
                {
                  scrollTop: $parent.offset().top - 80,
                },
                800,
              );
            }
            return false;
          }

          if (key === 'ADDINTERACTION' || key === 'OPEN_ACTION') {
            let $targetEl;
            if ($target.data('gfmodule') != undefined) {
              $target.data('gfmodule').openModuleSettings('Design');
              $targetEl = $target;
            } else if ($target.data('gfrow') != undefined) {
              $target.data('gfrow').openRowSettings('Design');
              $targetEl = $target;
            } else if ($target.parent().data('gfrow') !== undefined) {
              $element = $target.parent();
              $target.data('gfrow').openRowSettings('Design');
              $targetEl = $element;
            } else if ($target.data('gfelement') != undefined) {
              $target.data('gfelement').openElementSettings('Design', undefined, undefined);
              $targetEl = $target;
            }
            if ($targetEl) {
              switch (key) {
                case 'ADDINTERACTION':
                  setTimeout(() => {
                    new InteractionPanel($targetEl);
                    const $gfTabs = $gfLeftSideBar.find('.simple-tabs');
                    if ($gfTabs && $gfTabs.data('gftabs')) {
                      $gfTabs.children('ul').hide();
                      $gfTabs.data('gftabs').gotoTab(2);

                      const tabItem = $gfLeftSideBar.find(
                        `.interactions-panel .tab-action-dropdown .tab-item[data-key=${itemClicked.data('key') || ''}]`,
                      );
                      tabItem.trigger('click');
                    }
                  });

                  break;
                case 'OPEN_ACTION':
                  if ($targetEl) {
                    setTimeout(() => {
                      if (typeof window.__gfFlowActionsPanel != 'undefined') {
                        delete window.__gfFlowActionsPanel;
                      }

                      window.__gfFlowActionsPanel = new FlowActionsPanel($targetEl);
                      const $gfTabs = $gfLeftSideBar.find('.simple-tabs');

                      if (
                        $gfTabs != undefined &&
                        $gfTabs.data('gftabs') != undefined &&
                        $gfTabs.children('.actions-panel').length
                      ) {
                        const actionIndex = $gfTabs.children('.actions-panel').index() - 1;
                        $gfTabs.children('ul').hide();
                        $gfTabs.data('gftabs').gotoTab(actionIndex);
                      }
                    });
                  }
                  break;
              }
            }
          }

          if ($target.hasClass('element-wrap')) {
            switch (key) {
              case 'SETTINGS':
                if ($target.data('gfelement') !== undefined) {
                  $target.data('gfelement').openElementSettings();
                }
                break;

              case 'EDIT_CODE':
                $target.data('gfelement').editCode(dataSections);
                break;

              case 'COPY_CSS':
                $target.data('gfelement').copyCSS();
                break;

              case 'PASTE_CSS':
                $target.data('gfelement').pasteCSS();
                break;

              case 'CLONE':
                $target.data('gfelement').cloneMe();
                break;

              case 'DELETE':
                $target.data('gfelement').doRemoveMe(undefined, true);
                $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                break;

              case 'EXPORT': {
                handleAddToLibrary($target);
                // app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $target });
                break;
              }

              case 'MOVEUP':
                $target.data('gfelement').moveUp();
                break;

              case 'MOVEDOWN':
                $target.data('gfelement').moveDown();
                break;

              case 'TOPARENT':
                $target.data('gfelement').toParent();
                break;
            }
          } else if ($target.hasClass('module-wrap')) {
            if ($target.data('gfmodule') !== undefined) {
              switch (key) {
                case 'SETTINGS':
                  $target.data('gfmodule').openModuleSettings();
                  break;

                case 'EDIT_CODE':
                  $target.data('gfmodule').editCode(dataSections);
                  break;

                case 'COPY_CSS':
                  $target.data('gfmodule').copyCSS();
                  break;
                case 'PASTE_CSS':
                  $target.data('gfmodule').pasteCSS();
                  break;

                case 'CLONE':
                  $target.data('gfmodule').cloneMe();
                  break;

                case 'DELETE':
                  $target.data('gfmodule').doRemoveMe();
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  break;

                case 'EXPORT': {
                  handleAddToLibrary($target);
                  // app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $target });
                  break;
                }

                case 'MOVEUP':
                  $target.data('gfmodule').moveUp();
                  break;
                case 'MOVEDOWN':
                  $target.data('gfmodule').moveDown();
                  break;
                case 'TOPARENT':
                  $target.data('gfmodule').toParent();
                  break;
              }
            }
          } else if ($target.hasClass('gf_column')) {
            const $row = $target.parent();
            if ($row.data('gfrow') !== undefined) {
              switch (key) {
                case 'SETTINGS':
                  $row.data('gfrow').openRowSettings();
                  break;

                case 'EDIT_CODE':
                  $row.data('gfrow').colCSS($target, dataSections);
                  break;
                // case 'CSS':
                //     $row.data('gfrow').colCSS($target, dataSections);
                //     break;

                case 'CLONE':
                  $row.data('gfrow').cloneMe();
                  break;

                case 'DELETE':
                  $row.data('gfrow').doRemoveMe();
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  break;

                case 'EXPORT': {
                  handleAddToLibrary($target);
                  // app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $row });
                  break;
                }

                case 'MOVEUP':
                  $row.data('gfrow').moveUp();
                  break;
                case 'MOVEDOWN':
                  $row.data('gfrow').moveDown();
                  break;
                case 'TOPARENT':
                  $row.data('gfrow').toParent();
                  break;
              }
            }
          } else if ($target.hasClass('gf_row')) {
            if ($target.data('gfrow') !== undefined) {
              switch (key) {
                case 'SETTINGS':
                  $target.data('gfrow').openRowSettings();
                  break;

                case 'EDIT_CODE':
                  $target.data('gfrow').rowCSS(dataSections);
                  break;

                case 'COPY_CSS':
                  $target.data('gfrow').copyCSS();
                  break;
                case 'PASTE_CSS':
                  $target.data('gfrow').pasteCSS();
                  break;

                case 'CLONE':
                  $target.data('gfrow').cloneMe();
                  break;

                case 'DELETE':
                  $target.data('gfrow').doRemoveMe();
                  $gfLeftSideBar.data('gfleftsidebar').gotoTab(0);
                  break;

                case 'EXPORT': {
                  handleAddToLibrary($target);
                  // app.$store.commit(`library/${mutations.OPEN_CREATE_LIB}`, { type: 'block', target: $target });
                  break;
                }

                case 'MOVEUP':
                  $target.data('gfrow').moveUp();
                  break;
                case 'MOVEDOWN':
                  $target.data('gfrow').moveDown();
                  break;
                case 'TOPARENT':
                  $target.data('gfrow').toParent();
                  break;
              }
            }
          } else {
            return false;
          }
        },
      });

      // events
      $element.on('drag-active', function () {
        // to update placeholder
        $gryffEditor.data('gryffeditor').updatePlaceHolders();

        // fix Youtube Video Module,
        $gryffBody.find('[data-label="Youtube"]').each(function () {
          jQuery(this).find('.gf_youtube-overlay').addClass('show');
        });
        $gryffBody.find('[data-label="Vimeo"]').each(function () {
          jQuery(this).find('.gf_vimeo-overlay').addClass('show');
        });

        //fix Google Maps module
        $gryffBody.find('[data-label="Google Maps"]').each(function () {
          jQuery(this).find('.gf_gmaps-overlay').addClass('show');
        });
      });

      $element.on('drag-deactive', function () {
        // fix Youtube Video Google Maps Module,
        setTimeout(function () {
          $gryffBody.find('[data-label="Youtube"]').each(function () {
            jQuery(this).find('.gf_youtube-overlay').removeClass('show');
          });
          $gryffBody.find('[data-label="Vimeo"]').each(function () {
            jQuery(this).find('.gf_vimeo-overlay').removeClass('show');
          });

          $gryffBody.find('[data-label="Google Maps"]').each(function () {
            jQuery(this).find('.gf_gmaps-overlay').removeClass('show');
          });
        }, 100);
      });

      // Init render button: Save, Public, Preview
      // 1. Đã publish thì không quan tâm save
      // 2. Chưa publish thì có thể publish và save
      // 3. Chưa publish htì có thể publish và k thể save
      // 4. Đã Publish vẫn có thể makedefault ngoài subpage

      const _isMakeDefault = gfFrameData.isPublishPage();
      store.setValue('__isMakeDefault', _isMakeDefault);
      const $btnPreview = $divTopBar.find('.gf-preview-btn');

      store.onChange('__isSaved', function (value) {
        if (value === false) {
          // Có sự thay đổi thì set vào isPublish
          store.setValue('__isPublished', false);
        }

        // always enabled preview button

        // const messageTooltipsLockPreview = 'Please save your page before previewing';
        // const publish = store.getValue('__isPublished');
        // if (publish === false) {
        //   if (value === false) {
        //     // Chưa được save
        //     $btnPreview.attr('lock', 'true').attr('disabled', true);
        //     const url = $btnPreview.attr('href');
        //     $btnPreview.attr('data-href', url).removeAttr('href');

        //     // Hiển thị tool tips Preview button
        //     if ($btnPreview.data('gftooltipsnew') === undefined) {
        //       $btnPreview.gfTooltipsNew({
        //         postion: 'left',
        //         desc: messageTooltipsLockPreview,
        //       });
        //     }
        //   } else {
        //     // Đã được save or publish
        //     $btnPreview.removeAttr('lock').removeAttr('disabled');
        //     const url = $btnPreview.attr('data-href');
        //     $btnPreview.attr('href', url).removeAttr('data-href');
        //     // Bỏ sự kiện hiện Tooltips Preview button
        //     if ($btnPreview.data('gftooltipsnew') !== undefined) {
        //       $btnPreview.data('gftooltipsnew').stop();
        //     }
        //   }
        // } else {
        //   $btnPreview.removeAttr('lock').removeAttr('disabled');
        //   const url = $btnPreview.attr('data-href');
        //   $btnPreview.attr('href', url).removeAttr('data-href');
        //   // Bỏ sự kiện hiện Tooltips Preview button
        //   if ($btnPreview.data('gftooltipsnew') !== undefined) {
        //     $btnPreview.data('gftooltipsnew').stop();
        //   }
        // }
      });

      $divTopBar
        .find('#gf-preview')
        .off('click.lock')
        .on('click.lock', function (e) {
          if (store.getValue('__isSaved') === false) {
            e.preventDefault();
            return false;
          }
        });

      store.onChange('__isPublished', function (value) {
        if (value === true) {
          store.setValue('__isSaved', true);
        }
      });

      /* Event click button */
      // Ignore action when disabled state
      jQuery('#gf-preview')
        .off('click')
        .on('click', function () {
          $divTopBar.find('#gf-publish')?.data('gftooltipsnew')?.stop();
          if ($divTopBar.find('#gf-preview').hasClass('gf-disabled_action')) {
            return false;
          }
        });

      jQuery('.gf-update-btn')
        .off('click')
        .on('click', function () {
          if ($button.hasClass('gp-open-new-tab--apply-event')) return;

          try {
            disableNavBarAction();
            let $button = $divTopBar.find('.gf-upgrade-btn');
            if (!$button.length) {
              $button = $divTopBar.find('.gf-update-btn');
            }
            _this.savePage('save', $button, undefined, function () {});
          } catch (error) {
            console.log(error);
            enableNavBarAction();
          }
        });
      $divTopBar.find('.gf-publish-btn, .gf-save-btn, .gf-upgrade-btn').each(function () {
        jQuery(this)
          .off('click')
          .on('click', function () {
            const $button = jQuery(this);
            if ($button.hasClass('gp-open-new-tab--apply-event')) return;

            $divTopBar.find('#gf-publish')?.data('gftooltipsnew')?.stop();

            let saveType = $button.attr('data-saveType');
            if ($button.hasClass('gf-disabled_action')) {
              return false;
            }

            if ($button.attr('lock') !== 'true') {
              switch (saveType) {
                case 'save':
                  _this.savePage(saveType, $button, undefined, function () {});
                  break;
                case 'publish':
                  _this.renderPopupPublish(saveType);
                  break;
              }

              // Add to gfCount
              const extraCount = {};
              if ($button.hasClass('gf-upgrade-btn')) {
                saveType = 'upgrade';
              }
              if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                $gryffEditor.data('gfcount').add(saveType, extraCount);
              }
            }

            return false;
          });
      });

      // SET page name.
      const $pageInfo = $divTopBar.children('#pageInfo');
      app.$store.commit('page/SET_DEFAULT_PAGE_TITLE', gfFrameData.getPageTitle());

      $divTopBar
        .children('#pageInfo')
        .find('a')
        .off('click')
        .on('click', function (e) {
          if (!store.getValue('__isSaved')) {
            const $a = jQuery(this);
            e.preventDefault();
            const _template =
              '<div class="md-confirm" id="md-confirm-exit"><div class="gf_close-btn"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16.4966 7.50336C16.7746 7.78135 16.7746 8.23207 16.4966 8.51007L13.0067 12L16.4966 15.4899C16.7746 15.7679 16.7746 16.2186 16.4966 16.4966C16.2186 16.7746 15.7679 16.7746 15.4899 16.4966L12 13.0067L8.51007 16.4966C8.23207 16.7746 7.78135 16.7746 7.50336 16.4966C7.22536 16.2186 7.22536 15.7679 7.50336 15.4899L10.9933 12L7.50336 8.51007C7.22536 8.23207 7.22536 7.78135 7.50336 7.50336C7.78135 7.22536 8.23207 7.22536 8.51007 7.50336L12 10.9933L15.4899 7.50336C15.7679 7.22536 16.2186 7.22536 16.4966 7.50336Z" fill="#383F44"/></svg></div><h3>Are you sure to exit?</h3> <p>Changes are not saved yet. Are you sure you want to discard changes and return to dashboard?</p> <div class="md-confirm-button"> <button data-action="discard">Discard changes</button> <button data-action="cancel">Cancel</button> </div> </div>';
            const $activeModal = jQuery('#md-back');
            $activeModal.gfModalNew({
              header: '',
              footer: '',
              width: 500,
              height: 260,
              center: true,
              onContent: function ($content) {
                $content.html(_template);
              },
            });

            $activeModal.data('gfmodalnew').onShow();
            $activeModal
              .find('button[data-action="discard"]')
              .off()
              .on('click', function (e) {
                $activeModal.data('gfmodalnew').onClose();
                store.setValue('__isSaved', true);
                window.location.href = $a.attr('href');
                return false;
              });
            $activeModal
              .find('button[data-action="cancel"], .gf_close-btn')
              .off()
              .on('click', function (e) {
                $activeModal.data('gfmodalnew').onClose();
                return false;
              });
            return false;
          }
        });

      return false;
    };

    // Chỗ này chậm
    this.loadLiquid = function () {
      /* **** INIT!!!!!!!! **** */
      /* put inside gf left sidebar to make sure all snippets loaded */
      // $element.find('> .gf_row').gfRow();

      atom.Init($element.find('> .gf_row'));

      // $element.find('> .module-wrap').gfModule();
      console.time('LOAD-FRE');
      atom.Init($element.find('> .module-wrap'));

      // $element.find('> .element-wrap').gfElement();
      atom.Init($element.find('> .element-wrap'));
      console.timeEnd('LOAD-FRE');
      // POPUP without products
      // POPUP without product list
      const countProductsInPopups = $gryffBody.find('> [data-label="Popup"] [data-label="Product"]').length;
      const countProductListsInPopups = $gryffBody.find('> [data-label="Popup"] [data-label="Product List"]').length;
      if (countProductsInPopups === 0 && countProductListsInPopups === 0) {
        // $gryffBody.find('> .module-wrap').gfModule();
        atom.Init($gryffBody.find('> .module-wrap'));
      }

      // init product in product template
      const gType = gfFrameData.getPageType();

      // !!!! preload all products

      _this.initProductModules(function () {
        _this.initProductListModules(function () {
          // POPUP has products or product lists
          if (countProductsInPopups > 0 || countProductListsInPopups > 0) {
            $gryffBody.find('> .module-wrap').each(function () {
              if (jQuery(this).data('gfmodule') != undefined) {
                jQuery(this).data('gfmodule').refresh();
              } else {
                atom.Init(jQuery(this));
              }
            });
          }

          // OTHER PAGES
          if (gType !== 'template-product') {
            $gryffBody
              .find(
                '.module-wrap[data-label="Product"][data-status="default"], .module-wrap[data-label="Product"][data-status="dynamic"], .module-wrap[data-label="Related Products"]',
              )
              .each(function () {
                if (jQuery(this).data('gfmodule') != undefined) {
                  jQuery(this).data('gfmodule').setDynamic(false);
                }
              });
          }

          // Check is empty page, and insert a default product or collection to it
          if (
            $element.find('.gf_row').length === 0 &&
            $element.find('.element-wrap').length === 0 &&
            $element.find('.module-wrap').length === 0
          ) {
            if (gType === 'template-product') {
              _this.initProductTemplate();
              app.$store.commit('page/UPDATE_IS_INIT_PRELOAD_PRODUCT_SNIPPET', true);
            }
            if (gType === 'template-collection') {
              _this.initCollectionTemplate();
            }
          }

          window.__gpAutoFixTemplate = {
            label: 'collection',
          };

          const pageInfoData = app.$store.getters['app/pageInfoData'];
          // if page is created from GP template
          if (pageInfoData && !pageInfoData.lastAction && pageInfoData.templateID > 0) {
            _this.addEditorContent(undefined, undefined, undefined, undefined, {
              isCreatedFromTemplate: true,
            });
          }

          // Preload latest product
          if (isLandingPage()) {
            _this.preloadLatestData();
          }

          //End loading Editor
          app.$store.commit('editor/SET_LOADING_EDITOR', false);
        });
      });
    };

    this.generateAssignBox = function (data, pageType) {
      const templateData = {
        'template-product': {
          assignmentURL:
            'https://help.gempages.net/articles/Create-and-assign-a-custom-product-page-for-a-specific-product-gempages',
          text: 'product',
        },
        'template-collection': {
          assignmentURL:
            'https://help.gempages.net/articles/create-and-assign-a-custom-collection-page-for-a-specific-collection',
          text: 'collection',
        },
      };

      let assignmentURL = '';
      let text = '';
      if (templateData[pageType]) {
        text = templateData[pageType].text;
        assignmentURL = templateData[pageType].assignmentURL;
      }

      let quickAssignTemplate = `
                <p>If you want to assign current template to a specific ${text}, please go to
                    <a href="${assignmentURL}" target="_blank">
                        ${HELPER.capitalizeFirstLetter(text)} Assignments
                        <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M4.5 2.5H2V10.5H10V8" stroke="#3C67FF"/>
                            <path d="M6.5 2.5H10.0001M10.0001 2.5L10 6M10.0001 2.5L5 7.5" stroke="#3C67FF"/>
                        </svg>
                    </a>
                </p>
            `;

      if (pageType === 'template-index') {
        quickAssignTemplate = `
                    <p>If you want to make current template visibile on live page, make default to replace your current home page with this one.</p>
                `;
      }

      return (
        `
            <div class="ui-preview-container">` +
        `<div class="assignProduct preview-right">
                    <div class="assignProductBody">` +
        `<a href="${data.urlGlobal}" target="_blank" class="assignProductBox assignProductBoxGlobal" data-image-name="view-live">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none"xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                d="M10.5219 10.124C10.4672 10.3449 10.269 10.5 10.0415 10.5H6.35C6.1713 10.5 6.00619 10.4046 5.9169 10.2498C5.8276 10.0951 5.82771 9.90438 5.91717 9.74969C7.17719 7.5709 9.18553 5.90383 11.6005 5.07696C11.7953 5.01027 12.0111 5.06979 12.1441 5.22691C12.2771 5.38404 12.3003 5.60664 12.2024 5.78776C11.4731 7.13685 10.9125 8.5983 10.5219 10.124ZM18.3695 24.9321C17.9409 25.0616 17.5745 24.6004 17.7976 24.2122C18.5269 22.8631 19.0875 21.4017 19.4781 19.876C19.5348 19.6548 19.7341 19.5 19.9625 19.5H23.65C23.8289 19.5 23.9942 19.5956 24.0834 19.7507C24.1726 19.9058 24.1722 20.0968 24.0822 20.2514C22.8229 22.4157 20.8156 24.0958 18.3995 24.923L18.3695 24.9321ZM23.65 10.5C23.8289 10.5 23.9942 10.4044 24.0834 10.2493C24.1726 10.0942 24.1722 9.90321 24.0822 9.74855C22.8229 7.58425 20.8156 5.90422 18.3995 5.07696C18.2047 5.01027 17.9889 5.06979 17.8559 5.22691C17.7229 5.38404 17.6997 5.60664 17.7976 5.78776C18.5269 7.13685 19.0875 8.5983 19.4781 10.124C19.5348 10.3452 19.7341 10.5 19.9625 10.5H23.65ZM15.4112 4.76557C15.3178 4.63057 15.1641 4.55 15 4.55C14.8359 4.55 14.6822 4.63057 14.5888 4.76557C13.5224 6.30739 12.6866 8.01711 12.1337 9.85602C12.0881 10.0074 12.1169 10.1715 12.2113 10.2983C12.3056 10.4252 12.4544 10.5 12.6125 10.5H17.3875C17.5456 10.5 17.6944 10.4252 17.7887 10.2983C17.8831 10.1715 17.9118 10.0074 17.8663 9.85602C17.3134 8.01711 16.4776 6.30739 15.4112 4.76557ZM4.83993 17.6213C4.89557 17.8439 5.09557 18 5.325 18H9.55C9.69309 18 9.82932 17.9387 9.92422 17.8316C10.0191 17.7245 10.0636 17.5819 10.0464 17.4398C9.94746 16.6238 9.875 15.8212 9.875 15C9.875 14.1788 9.94746 13.3762 10.0464 12.5602C10.0636 12.4181 10.0191 12.2755 9.92422 12.1684C9.82932 12.0613 9.69309 12 9.55 12H5.325C5.09557 12 4.89557 12.1561 4.83993 12.3787C4.63198 13.2105 4.5 14.0892 4.5 15C4.5 15.9108 4.63198 16.7895 4.83993 17.6213ZM6.35 19.5C6.07386 19.5 5.85 19.7239 5.85 20C5.85 20.0944 5.87615 20.1827 5.9216 20.258C7.1819 22.433 9.18837 24.0971 11.6005 24.923C11.7953 24.9897 12.0111 24.9302 12.1441 24.7731C12.2771 24.616 12.3003 24.3934 12.2024 24.2122C11.4731 22.8631 10.9125 21.4017 10.5219 19.876C10.4652 19.6548 10.2659 19.5 10.0375 19.5H6.35ZM14.5888 25.2344C14.6822 25.3694 14.8359 25.45 15 25.45C15.1641 25.45 15.3178 25.3694 15.4112 25.2344C16.4776 23.6926 17.3134 21.9829 17.8663 20.144C17.9118 19.9926 17.8831 19.8285 17.7887 19.7017C17.6944 19.5748 17.5456 19.5 17.3875 19.5H12.6125C12.4544 19.5 12.3056 19.5748 12.2113 19.7017C12.1169 19.8285 12.0881 19.9926 12.1337 20.144C12.6866 21.9829 13.5224 23.6926 14.5888 25.2344ZM17.925 18C18.175 18 18.3866 17.8153 18.4204 17.5676C18.5341 16.7341 18.625 15.8833 18.625 15C18.625 14.117 18.5342 13.2539 18.4203 12.4314C18.386 12.1841 18.1746 12 17.925 12H12.075C11.8254 12 11.614 12.1841 11.5797 12.4314C11.4658 13.2539 11.375 14.117 11.375 15C11.375 15.8833 11.4659 16.7341 11.5796 17.5676C11.6134 17.8153 11.825 18 12.075 18H17.925ZM19.9536 17.4398C19.9364 17.5819 19.9809 17.7245 20.0758 17.8316C20.1707 17.9387 20.3069 18 20.45 18H24.675C24.9044 18 25.1044 17.8439 25.1601 17.6213C25.368 16.7895 25.5 15.9108 25.5 15C25.5 14.0892 25.368 13.2105 25.1601 12.3787C25.1044 12.1561 24.9044 12 24.675 12H20.45C20.3069 12 20.1707 12.0613 20.0758 12.1684C19.9809 12.2755 19.9364 12.4181 19.9536 12.5602C20.0525 13.3762 20.125 14.1788 20.125 15C20.125 15.8212 20.0525 16.6238 19.9536 17.4398ZM3 15C3 8.37549 8.36429 3 14.9875 3C21.6242 3 27 8.37647 27 15C27 21.6235 21.6242 27 14.9875 27C8.36429 27 3 21.6245 3 15Z"
                                fill="#85929E" />
                            </svg>
                            <div class="assignProductText">
                                <p>View Live Page</p>
                                <span>View current <b>live product page</b> with selected product</span>
                            </div>
                        </a>
                        <a href="${data.urlTemplate}" target="_blank" class="assignProductBox assignProductBoxTemplate" data-image-name="preview">
                            <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M4.6049 15C6.41863 19.4878 10.441 22.5 15 22.5C19.559 22.5 23.5814 19.4878 25.3951 15C23.5814 10.5122 19.559 7.5 15 7.5C10.441 7.5 6.41863 10.5122 4.6049 15ZM3.12498 14.6639C5.08705 9.57397 9.66221 6 15 6C20.3378 6 24.913 9.57397 26.8751 14.6639C26.9584 14.88 26.9584 15.12 26.8751 15.3361C24.913 20.426 20.3378 24 15 24C9.66221 24 5.08705 20.426 3.12498 15.3361C3.04167 15.12 3.04167 14.88 3.12498 14.6639Z" fill="#85929E" />
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M15 18C16.6569 18 18 16.6569 18 15C18 13.3431 16.6569 12 15 12C13.3432 12 12 13.3431 12 15C12 16.6569 13.3432 18 15 18ZM15 19.5C17.4853 19.5 19.5 17.4853 19.5 15C19.5 12.5147 17.4853 10.5 15 10.5C12.5147 10.5 10.5 12.5147 10.5 15C10.5 17.4853 12.5147 19.5 15 19.5Z" fill="#85929E" /></svg>
                            <div class="assignProductText">
                                <p>Preview with Template</p>
                                <span>Preview <b>editing template</b> with selected product </span>
                            </div>
                        </a>
                    </div>
                    <div class="quickAssignProduct">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.99996 10.6707C7.5468 10.6707 7.17944 11.038 7.17944 11.4912C7.17944 11.9443 7.5468 12.3117 7.99996 12.3117C8.45311 12.3117 8.82047 11.9443 8.82047 11.4912C8.82047 11.038 8.45311 10.6707 7.99996 10.6707Z" fill="#3C67FF"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.99996 2.87183C8.45311 2.87183 8.82047 3.23918 8.82047 3.69234V8.9573C8.82047 9.41045 8.45311 9.77781 7.99996 9.77781C7.5468 9.77781 7.17944 9.41045 7.17944 8.9573V3.69234C7.17944 3.23918 7.5468 2.87183 7.99996 2.87183Z" fill="#3C67FF"/>
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12.4965 3.50353C10.0131 1.02019 5.98686 1.02019 3.50353 3.50353C1.02019 5.98686 1.02019 10.0131 3.50353 12.4965C5.98686 14.9798 10.0131 14.9798 12.4965 12.4965C14.9798 10.0131 14.9798 5.98686 12.4965 3.50353ZM2.34315 2.34315C5.46734 -0.781049 10.5327 -0.781049 13.6569 2.34315C16.781 5.46734 16.781 10.5327 13.6569 13.6569C10.5327 16.781 5.46734 16.781 2.34315 13.6569C-0.781049 10.5327 -0.781049 5.46734 2.34315 2.34315Z" fill="#3C67FF"/>
                        </svg>
                        ${quickAssignTemplate}
                    </div>
                </div>
            </div>
            `
      );
    };

    this.initProductTemplate = function () {
      /**
       * Snippet JSON API
       *
       * @param {string} label MER label to initialize
       * @param {Object} settings MER settings to override default settings
       * @param {array} items List of children inside current MER
       * @param {number} placeholder in where of current MER you want the item to be inserted
       *     In case of Row, placeholder stands for columns
       *     In case of Tab and Accordion, placeholder stands for tabs
       *     In case of Carousel, placeholder stands for slides
       *     By default, placeholder will be the first .block-placeholder available
       */
      const preloadSnippets = [
        {
          label: 'Product',
          settings: {
            dynamic: '1',
          },
          items: [
            {
              label: 'Row',
              settings: {
                'gf_row-layout': '6+6',
                'gf_row-layout-md': '6+6',
                'gf_row-layout-sm': '6+6',
                'gf_row-layout-xs': '12+12',
              },
              items: [
                {
                  label: '(P) Image',
                  settings: {
                    width: '100%',
                  },
                  placeholder: 0,
                },
                {
                  label: '(P) Image List',
                  placeholder: 0,
                },
                {
                  label: '(P) Title',
                  settings: {
                    align_lg: 'left',
                    align_md: 'left',
                    align_sm: 'left',
                    align_xs: 'left',
                  },
                  placeholder: 1,
                },
                {
                  label: '(P) Price',
                  settings: {
                    align_lg: 'left',
                    align_md: 'left',
                    align_sm: 'left',
                    align_xs: 'left',
                  },
                  placeholder: 1,
                },
                {
                  label: '(P) Swatches',
                  settings: {
                    align_lg: 'left',
                    align_md: 'left',
                    align_sm: 'left',
                    align_xs: 'left',
                  },
                  placeholder: 1,
                },
                {
                  label: '(P) Quantity',
                  settings: {
                    align_lg: 'left',
                    align_md: 'left',
                    align_sm: 'left',
                    align_xs: 'left',
                  },
                  placeholder: 1,
                },
                {
                  label: '(P) Cart Button',
                  settings: {
                    align_lg: 'left',
                    align_md: 'left',
                    align_sm: 'left',
                    align_xs: 'left',
                  },
                  placeholder: 1,
                },
              ],
            },
          ],
          preloadSnippetProduct: true,
        },
      ];

      // Preload from the end of the list
      HELPER.addSnippetToEditor(preloadSnippets, preloadSnippets.length - 1);
    };

    this.initCollectionTemplate = function () {
      // COLLECTION DESIGN
      _this.initCollections(function (initCollection) {
        let preloadSnippets;
        if ($gryffBody.find('.module-wrap, .element-wrap, .gf_row').length === 0) {
          // Preload snippets will be rendered in reverse order
          preloadSnippets = [
            {
              label: 'Row',
              settings: {
                'row-type': '1',
              },
              items: [
                {
                  label: 'Collection Banner',
                  settings: {
                    overlayColor: '#000000',
                    overlayOpacity: 0.2,
                  },
                },
                {
                  label: 'Collection Toolbar',
                },

                {
                  label: 'Product List',
                  settings: {
                    dynamic: '1',
                  },
                },
                {
                  label: 'Paginator',
                },
              ],
            },
          ];

          if (initCollection !== undefined) {
            preloadSnippets[0].items[1].settings = {
              collection: initCollection.title,
              cId: initCollection.id,
              cHandle: initCollection.handle,
              dynamic: '1',
            };
          }
        } else {
          preloadSnippets = [
            {
              label: 'Product List',
              settings: {
                dynamic: '1',
              },
            },
          ];
          if (initCollection !== undefined) {
            preloadSnippets[0].settings = {
              collection: initCollection.title,
              cId: initCollection.id,
              cHandle: initCollection.handle,
              dynamic: '1',
            };
          }
        }

        HELPER.addSnippetToEditor(preloadSnippets, preloadSnippets.length - 1);
      });
    };

    this.showToolTipsPublish = async function () {
      // The A/B tip is rendered from state, so give the lookup started on publish a short grace
      // period — otherwise a page that already has a campaign would still be offered a new one.
      // It self-times-out and never rejects, so the tooltip below is rendered either way.
      await waitForTemplateCampaign();

      // Show box tooltips
      const pageType = gfFrameData.getPageType();
      let $btnView = $divTopBar.find('#gf-view');
      const leftViewTooltip = jQuery(window).width() - 400 - 32;
      const urlGlobal = $divTopBar.find('#gf-view').attr('origin-href');
      const tooltipConfig = {
        style: 'custom',
        title: 'Live Page',
        class: 'popup-preview-chooser',
        type: 'click',
        width: '378px',
        postion: 'bottom',
        postionTop: '57px',
        postionLeft: leftViewTooltip + 'px',
        arrowPostionLeft: '9990%',
        closer: '.closer',
        backgroundColor: 'white',
      };
      if (['template-page', 'template-article'].includes(pageType)) {
        $btnView.addClass('hightlight');
        const desc = `After published, you can click on "eyes" button to view your live page.</br> If you want to add your page to the menu / navigation.  Please check Shopify official tutorial.`;
        $btnView.gfTooltipsNew({
          ...tooltipConfig,
          template: liveView({ liveUrl: urlGlobal, pageType: pageType }),
          onClickPrimary: function () {
            $btnView.removeClass('hightlight');
          },
          onStop: function (force) {
            if (force) {
              setTimeout(function () {
                $btnView.removeClass('hightlight');
              }, 1000);
            } else {
              $btnView.removeClass('hightlight');
            }
          },
        });
        $btnView.data('gftooltipsnew').start();
      } else {
        // Hiển thị box view live pages
        const _isMakeDefault = store.getValue('__isMakeDefault');
        $btnView = $divTopBar.find('#gf-publish');
        if ($btnView.data('gftooltipsnew') !== undefined) {
          $btnView.data('gftooltipsnew').stop();
        }
        const idPageTemplate = _this._getParameterByName('id');
        const urlTemplate = urlGlobal + '?view=gem-' + idPageTemplate + '-template&live=true';
        if (_isMakeDefault) {
          $btnView.gfTooltipsNew({
            ...tooltipConfig,
            template: liveView({
              liveUrl: urlGlobal,
              pageType: pageType,
            }),
          });
        } else if (pageType === 'template-index') {
          $btnView.gfTooltipsNew({
            ...tooltipConfig,
            title: 'This template is not set as default yet',
            template: liveView({
              liveUrl: urlGlobal,
              templateUrl: urlTemplate,
              pageType: pageType,
            }),
          });
        } else if (pageType === 'template-product') {
          const { total, statusProductDynamic } = app.$store.state['page']['assignedProduct'];
          const desc = ['draft', 'archived'].includes(statusProductDynamic)
            ? `You can't view the live page because you assigned <b>the ${statusProductDynamic} product</b>. You need to activate the product in Shopify admin.`
            : null;
          const templateUrl = total === 0 ? urlTemplate : null;
          $btnView.gfTooltipsNew({
            ...tooltipConfig,
            title: 'This template is not set as default yet',
            template: liveView({
              liveUrl: urlGlobal,
              templateUrl: templateUrl,
              desc: desc,
              pageType: pageType,
            }),
          });
        } else if (pageType === 'template-collection') {
          $btnView.gfTooltipsNew({
            ...tooltipConfig,
            title: 'This template is not set as default yet',
            template: liveView({
              liveUrl: urlGlobal,
              templateUrl: urlTemplate,
              pageType: pageType,
            }),
          });
        }
        if ($btnView.data('gftooltipsnew') !== undefined) {
          $btnView.data('gftooltipsnew').start();
        }
      }

      _this.addAbTestingTipTracking();
    };

    this.addAbTestingTipTracking = function () {
      // Navigation is handled by the anchor's href + target="_blank"; here we only
      // fire the click tracking so analytics can split install-vs-create funnel.
      const abTestingLink = document.getElementById('gemXAbTestingTipLink');

      if (!abTestingLink) return;

      abTestingLink.addEventListener('click', () => {
        app.$store.dispatch('common/trackEvent', {
          eventId: EDITOR_EVENT.AB_TESTING_TIP_CLICKED,
          properties: {
            shop_domain: getParameterByName('shop'),
            page_type: abTestingLink.dataset.pageType || '',
            is_connected: abTestingLink.dataset.connected === 'true',
            has_campaign: abTestingLink.dataset.hasCampaign === 'true',
            is_campaign_group: abTestingLink.dataset.campaignGroup === 'true',
            destination_url: abTestingLink.href,
          },
        });
      });
    };

    this.preloadLatestData = function () {
      const shop = gfFrameData.getShopDomain();
      getLatestProduct(() => {}, shop);
    };

    this.renderPopupPublish = async function (saveType) {
      let lazyload;
      let _meta;
      let _handle;
      let _title;
      let $mdPageConfirmPublish;
      const isPublish = store.getValue('__isMakeDefault');
      const gType = gfFrameData.getPageType();

      // ===== LimitPublishPage Feature ===== //
      const publishedPage = storeX.getters['app/publishedPage'];
      const limitPublishPage = storeX.getters['app/limitPublishPage'];
      const isLimitPublish = storeX.getters['app/isLimitPublish'];
      const pagePlan = storeX.getters['app/pagePlan'];
      if (isLimitPublish) {
        if (pagePlan == PLAN_NAMES.BUILD && (gType == PAGE_TYPES.PRODUCT_PAGE || gType == PAGE_TYPES.ARTICLE_PAGE)) {
          if (publishedPage >= limitPublishPage && publishedPage > 0) {
            return;
          }
        }
        if (pagePlan == PLAN_NAMES.TRIAL_2022) {
          if (publishedPage >= limitPublishPage && publishedPage > 0) {
            return;
          }
        }
      }
      // =========================== //

      // ===== GemMeter Feature ===== //
      let refDegProgress = 0;
      if (isLandingPage()) {
        const { degProgressValue, save } = useGemMeter();
        refDegProgress = degProgressValue.value;
        app.$store.commit(`gemMeter/${MutationTypes.CHANGE_MODAL_VISIBILITY}`, false);
      }
      // =========================== //

      const isApplyPreset = app.$store.state['app']['shopMeta']['onboardingGlobalStyle']['applyPreset'];
      if (isApplyPreset) {
        app.$store.state['app']['shopMeta']['onboardingGlobalStyle']['publicPreset'] = true;
      }

      if ($divTopBar.find('#gf-view').data('gftooltipsnew') !== undefined) {
        $divTopBar.find('#gf-view').data('gftooltipsnew').stop();
      }

      if ($divContentHidden.find('#md-page-confirm-publish').length > 0) {
        // Re-open Publish popup
        $divContentHidden.find('#md-page-confirm-publish').addClass('show');

        const generalForm = app.$store.getters['page/generalForm'];
        const advanceForm = app.$store.getters['page/advanceForm'];

        $mdPageConfirmPublish = $divContentHidden.children('#md-page-confirm-publish');

        const $inputTitle = $mdPageConfirmPublish.find('.confirm_publish [name="title"]');
        const $inputHandle = $mdPageConfirmPublish.find('.confirm_publish [name="handle"]');
        const $inputDescription = $mdPageConfirmPublish.find('.confirm_publish [name="desc"]');

        $inputTitle.val(generalForm.title).trigger('keyup');
        $inputHandle.val(generalForm.handle).trigger('keyup');
        $inputDescription.val(generalForm.description).trigger('keyup');

        $mdPageConfirmPublish
          .find('.confirm_publish #switch-shadow')
          .data('gfswitcher')
          .setValue(advanceForm.lazyLoad ? 1 : 0);

        // ===== GemMeter Feature ===== //
        if (isLandingPage()) {
          const $meter = $mdPageConfirmPublish.find('.confirm_publish').find('.meter');
          if ($meter.length > 0) {
            $meter.html(templateGemMeterProgressBar(refDegProgress));
          }

          $meter.off('click').on('click', function () {
            _this.hidePopupConfirmPublish();
            storeX.state.gemMeter.openModal = true;
            trackEvent({ eventId: GEM_METER_EVENT_ID.SHOW_THIS_ISSUE });
          });
        }
        // =========================== //
      } else {
        // First open Publish popup
        $divContentHidden.append('<div id="md-page-confirm-publish" class="show"></div>');
        $mdPageConfirmPublish = $divContentHidden.children('#md-page-confirm-publish');
        // on click body close;

        $mdPageConfirmPublish.off('mousedown.closeBody').on('mousedown.closeBody', function (e) {
          if (e.which != 3) {
            if ($(e.target).closest('.body_confirm_publish').length == 0) {
              $mdPageConfirmPublish.remove();
            }
          }
        });

        // Quyết định đã make chưa;
        let _isMakeDefault = 'active';
        let _text_isMakeDefault = 'Make default';
        const _publish = '';
        const _publish_text = 'Publish';
        const _publish_button_text = 'Publish';

        if (isPublish) {
          _isMakeDefault = '';
          _text_isMakeDefault = 'Discard Default';
        }

        const generalForm = app.$store.getters['page/generalForm'];
        const productAssignedList = app.$store.getters['page/GET_ASSIGNED_PRODUCT_LIST'];
        const pAssigned = productAssignedList.length > 0;
        _title = generalForm.title;
        _handle = generalForm.handle;
        _meta = generalForm.description;

        const gType = gfFrameData.getPageType();
        const pageInfo = store.getValue('__page');

        let campaignLink = '';
        if (typeof pageInfo?.campaign_id == 'number') {
          campaignLink = `${window.location.origin}/analytics/experiments/${pageInfo.campaign_id}`;
        }

        const pageInfoData = app.$store.getters['app/pageInfoData'];

        switch (gType) {
          case 'template-page': {
            $mdPageConfirmPublish.html(
              templateSubpage(
                {
                  fakePublishText: _publish_text,
                  title: _title,
                  handle: _handle,
                  meta: _meta,
                  btnText: _publish_button_text,
                  campaignLink,
                },
                refDegProgress,
              ),
            );
            break;
          }
          case 'template-article': {
            $mdPageConfirmPublish.html(
              templateArticlePage({
                fakePublishText: _publish_text,
                title: _title,
                handle: _handle,
                meta: _meta,
                btnText: _publish_button_text,
                campaignLink,
              }),
            );
            break;
          }
          case 'template-index': {
            $mdPageConfirmPublish.html(
              templateHomePage({
                fakePublishText: _publish_text,
                title: _title,
                publishBtn: {
                  class: _publish,
                  text: _publish_button_text,
                },
                campaignLink,
                confirmText: isPublish ? 'Yes' : 'Make Default',
              }),
            );
            break;
          }
          case 'template-collection': {
            $mdPageConfirmPublish.html(
              templateCollectionPage({
                fakePublishText: _publish_text,
                title: _title,
                publishBtn: {
                  class: _publish,
                  text: _publish_button_text,
                },
                campaignLink,
                confirmText: isPublish ? 'Yes' : 'Make Default',
              }),
            );
            break;
          }
          case 'template-product': {
            $mdPageConfirmPublish.html(
              templateProductPage({
                fakePublishText: _publish_text,
                title: _title,
                publishBtn: {
                  class: _publish,
                  text: _publish_button_text,
                },
                campaignLink,
                confirmText: isPublish ? 'Yes' : 'Make Default',
                pAssigned,
                gId: pageInfoData['g_id'],
              }),
            );
            break;
          }
        }

        $mdPageConfirmPublish
          .find('.warning-confirm_password')
          .off('click')
          .on('click', function () {
            emitter.emit('toggle-password', {
              source: 'public',
            });

            _this.hidePopupConfirmPublish();
          });

        $mdPageConfirmPublish
          .find('.confirm_publish')
          .find('.meter')
          .off('click')
          .on('click', function () {
            _this.hidePopupConfirmPublish();

            // ===== GemMeter Feature ===== //
            if (isLandingPage()) {
              storeX.state.gemMeter.openModal = true;
              trackEvent({ eventId: GEM_METER_EVENT_ID.SHOW_THIS_ISSUE });
            }
            // =========================== //
          });
        // LAZYLOADING2019
        const isLimitPublish = app.$store.state['app'].shopInfo?.isLimitPublish;
        const planPermissions = app.$store.state['app'].planPermissions;
        const advanceForm = app.$store.getters['page/advanceForm'];
        lazyload = advanceForm.lazyLoad;
        const shopPlan = gfFrameData.getShopPlan();
        if ($mdPageConfirmPublish.find('.lazy-load-option input').get().length > 0) {
          $mdPageConfirmPublish.find('.lazy-load-option input').get()[0].checked = lazyload;
        }

        $mdPageConfirmPublish.find('.confirm_publish #switch-shadow').gfSwitcher({
          // enable: shopPlan !== 'starter',
          enable: planPermissions[FEATURE_TYPES.LAZY_LOAD],
          value: lazyload ? 1 : 0,
          onSelected: function (value, $elm) {
            app.$store.commit('page/SET_DEFAULT_LAZY_LOADING', Boolean(value));
            gfFrameData.setPageLazyload(Boolean(value));
          },
          className: '!pb-0',
        });

        const $publicNow = $mdPageConfirmPublish.find('.publish_now');
        const $reachLimitPublic = $mdPageConfirmPublish.find('.reach-limit');

        // if (!isLimitPublish) {
        //   $publicNow.removeClass('disabled pointer-events-none');
        // }
        // } else {
        //   $reachLimitPublic.removeClass('hidden');
        // }

        // click publish;
        $mdPageConfirmPublish
          .find('.fake_publish')
          .off('click')
          .on('click', function () {
            $mdPageConfirmPublish.remove();
          });

        // click close icon notification assign
        const $closeIcon = $mdPageConfirmPublish.find('.close-nofi-assign');
        $closeIcon.gfTooltipsNew({
          postion: 'top',
          backgroundColor: '#676767',
          desc: 'Don&apos;t show it again',
          width: 'fit-content',
          subLeft: 50,
          arrowPostionLeft: '89%',
        });
        $closeIcon.off('click').on('click', function () {
          // Unbind clicked event to avoid memory leak
          const dataTooltip = jQuery(this).data('gftooltipsnew');
          if (dataTooltip) {
            dataTooltip.stop();
          }
          let type = $(this).data('id');
          const pageId = pageInfoData.id;
          let hideWarningPublishPopup = localStorage.getItem('hideWarningPublishPopup')
            ? JSON.parse(localStorage.getItem('hideWarningPublishPopup'))
            : {};

          if (!hideWarningPublishPopup[`${pageInfoData['g_id']}`]) {
            hideWarningPublishPopup[`${pageInfoData['g_id']}`] = {};
          }
          hideWarningPublishPopup[`${pageInfoData['g_id']}`][`${type}`] = true;
          localStorage.setItem('hideWarningPublishPopup', JSON.stringify(hideWarningPublishPopup));

          $mdPageConfirmPublish.find('#noti-' + type).remove();
        });

        // change input;

        let delay;
        $mdPageConfirmPublish
          .find('.confirm_publish_group input,.confirm_publish_group textarea')
          .off('keyup paste')
          .on('keyup paste', function () {
            const $that = $(this);
            const name = $that.attr('name');
            if (name == 'title') {
              _title = $that.val();
            } else if (name == 'handle') {
              _handle = HELPER.toHandle($that.val());
              $that.val(_handle);

              clearTimeout(delay);
              delay = setTimeout(function () {
                const gId = gfFrameData.getPageId();
                const gType = gfFrameData.getPageType();
                const shop = gfFrameData.getShopDomain();

                const data = {
                  shop: shop,
                  pageId: gId,
                  pageType: gType,
                  pageHandle: _handle,
                };
                const beforeSend = (xhr) => {
                  xhr.setRequestHeader('X-CSRF-Token', jQuery('meta[name="csrf-token"]').attr('content'));
                };
                // AJAX check handle
                POST(api.checkPageHandle().url, data, undefined, undefined, undefined, beforeSend)
                  .then((res) => {
                    const jsonData = res.data;
                    if (jsonData.status && jsonData.status == 'success') {
                      if (jsonData.pageId && jsonData.pageId != gId) {
                        $mdPageConfirmPublish
                          .find('.confirm_publish_group')
                          .next('.error_handle')
                          .html('<span>Page handle is already existed.</span>');
                        if (!$mdPageConfirmPublish.find('.publish_now').hasClass('not_submit')) {
                          $mdPageConfirmPublish.find('.publish_now').addClass('not_submit');
                          $mdPageConfirmPublish.find('.publish_now').off('click');
                        }
                      } else {
                        $mdPageConfirmPublish.find('.confirm_publish_group').next('.error_handle').html('');
                        $mdPageConfirmPublish.find('.publish_now').removeClass('not_submit');

                        // TODO: ahuhu
                        // Khởi tạo lại sự kiện click button publish now;
                        $mdPageConfirmPublish
                          .find('.publish_now')
                          .off('click')
                          .on('click', function () {
                            _this.handlePublishNow(_title, _handle, _meta, saveType, $mdPageConfirmPublish);
                            return false;
                          });
                      }
                    } else {
                      $mdPageConfirmPublish
                        .find('.confirm_publish_group')
                        .next('.error_handle')
                        .html('<span>Page handle is already existed.</span>');
                      if (!$mdPageConfirmPublish.find('.publish_now').hasClass('not_submit')) {
                        $mdPageConfirmPublish.find('.publish_now').addClass('not_submit');
                        $mdPageConfirmPublish.find('.publish_now').off('click');
                      }
                    }
                  })
                  .catch((err) => {
                    $mdPageConfirmPublish
                      .find('.confirm_publish_group')
                      .next('.error_handle')
                      .html('<span>Page handle is already existed.</span>');
                    if (!$mdPageConfirmPublish.find('.publish_now').hasClass('not_submit')) {
                      $mdPageConfirmPublish.find('.publish_now').addClass('not_submit');
                      $mdPageConfirmPublish.find('.publish_now').off('click');
                    }
                  });
              }, 400);
            } else if (name == 'desc') {
              const value = $that.val();
              _meta = value;

              //update count_desc_value;
              const $count_desc = $mdPageConfirmPublish.find('.count_desc_value');
              if (value.length > 320) {
                $count_desc.addClass('error');
              } else {
                $count_desc.removeClass('error');
              }
              $count_desc.text(value.length);
            }
          });

        // click publish now;
        $mdPageConfirmPublish
          .find('.publish_now')
          .off('click')
          .on('click', function () {
            _this.handlePublishNow(_title, _handle, _meta, saveType, $mdPageConfirmPublish);
            return false;
          });
        // click make default;
        $mdPageConfirmPublish
          .find('.makeDefault')
          .off('click')
          .on('click', function () {
            const $that = $(this);

            const gType = gfFrameData.getPageType();

            let label = '';
            switch (gType) {
              case 'template-index':
                label = 'home';
                break;

              case 'template-collection':
                label = 'collection';
                break;
              case 'template-product':
                label = 'product';
                break;
            }

            if (isPublish) {
              var message =
                'Make your original ' +
                label +
                " page as default. Click on 'eyes' button at the top right corner to check your live page.";
            } else {
              var message =
                'Replace your original ' +
                label +
                ' page with current template. If you\'re not ready yet, just hit "Save" button on the topbar instead.';
            }

            $mdPageConfirmPublish.find('.confirm_makeDefault_message').html(message);
            $mdPageConfirmPublish.find('.confirm_makeDefault').addClass('show');

            // Add to gfCount
            const extraCount = {};
            if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
              $gryffEditor.data('gfcount').add('makedefault', extraCount);
            }

            // click no;
            $mdPageConfirmPublish
              .find('.confirm_makeDefault .no')
              .off('click')
              .on('click', function () {
                $mdPageConfirmPublish.find('.confirm_makeDefault').removeClass('show');

                // Add to gfCount
                const extraCount = {};
                if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                  $gryffEditor.data('gfcount').add('no-makedefault', extraCount);
                }
              });

            // click yes;
            $mdPageConfirmPublish
              .find('.confirm_makeDefault .yes')
              .off('click')
              .on('click', function () {
                $mdPageConfirmPublish.find('.confirm_publish_loading').addClass('show');
                $mdPageConfirmPublish.find('.confirm_publish_loading_text').text('Make default');

                const gType = gfFrameData.getPageType();
                if (gType == 'template-index' || gType == 'template-collection' || gType == 'template-product') {
                  const gTitle = gfFrameData.getPageTitle();
                  const gHandle = gfFrameData.getPageHandle();
                  const gMeta = gfFrameData.getPageMeta();

                  const notification = false;

                  //after save your page then we make another request
                  let _default = '1';
                  if (isPublish) {
                    _default = '0';
                  }
                  const dataPage = {
                    title: gTitle,
                    handle: gHandle,
                    meta: gMeta,
                    default: _default,
                  };

                  _this.savePage(
                    'make_default',
                    undefined,
                    dataPage,
                    function (data) {
                      if (isPublish) {
                        gfFrameData.setPublishPage('false');
                        store.setValue('__isMakeDefault', false);
                      } else {
                        gfFrameData.setPublishPage('true');
                        store.setValue('__isMakeDefault', true);
                      }

                      $mdPageConfirmPublish.find('.confirm_publish_loading').addClass('success');
                      $mdPageConfirmPublish.find('.confirm_publish_loading_text').text('Success!');

                      // update editor link
                      _this.updateEditorUrl(gType, dataPage);

                      setTimeout(function () {
                        $mdPageConfirmPublish.find('.confirm_publish_loading').removeClass('success');
                        $mdPageConfirmPublish.find('.confirm_publish_loading').removeClass('show');
                        $mdPageConfirmPublish.find('.confirm_publish_loading_text').text('');

                        $mdPageConfirmPublish.find('.confirm_makeDefault').removeClass('show');

                        $mdPageConfirmPublish.fadeOut(500, function () {
                          $mdPageConfirmPublish.remove();
                        });

                        const $gfButtonView = $divTopBar.find('#gf-view');
                        $gfButtonView.addClass('hightlight');

                        // Show tooltips make default
                        if ($divTopBar.find('#gf-view').data('gftooltipsnew') != undefined) {
                          $divTopBar.find('#gf-view').data('gftooltipsnew').stop();
                        }
                        const leftViewTooltip = jQuery(window).width() - 350 - 5;
                        $divTopBar.find('#gf-view').gfTooltipsNew({
                          style: 'box',
                          title: 'Live Page',
                          desc: `After Make Default, you can click on "eyes" button to view your live page.`,
                          width: '350px',
                          postion: 'bottom',
                          postionTop: '57px',
                          postionLeft: leftViewTooltip + 'px',
                          arrowPostionLeft: '95%',
                          onStop: function (force) {
                            if (force) {
                              setTimeout(function () {
                                $gfButtonView.removeClass('hightlight');
                              }, 1000);
                            } else {
                              $gfButtonView.removeClass('hightlight');
                            }
                          },
                        });
                        if (isPublish) {
                          const pageType = gfFrameData.getPageType();
                          let desc = '';
                          if (pageType == 'template-index') {
                            desc = 'Your home page has just been returned to original template.';
                          } else if (pageType == 'template-product') {
                            desc = 'Your product page has just been returned to original template.';
                          } else if (pageType == 'template-collection') {
                            desc = 'Your collection page has just been returned to original template.';
                          }
                          if ($divTopBar.find('#gf-view').data('gftooltipsnew') != undefined) {
                            $divTopBar.find('#gf-view').data('gftooltipsnew').setOptions({
                              desc: desc,
                            });
                          }
                        }
                        $divTopBar.find('#gf-view').data('gftooltipsnew').start();
                      }, 500);
                    },
                    notification,
                  );
                }

                // Add to gfCount
                const extraCount = {};
                if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
                  $gryffEditor.data('gfcount').add('yes-makedefault', extraCount);
                }
              });
          });
      }
      return false;
    };
    this.handlePublishNow = function (title, handle, meta, saveType, $mdPageConfirmPublish) {
      const isLoadingEditor = app.$store.getters['editor/GET_LOADING_EDITOR'];
      const isLoadingDynamicData = app.$store.getters['editor/GET_LOADING_DYNAMIC_DATA'];

      if (isLoadingEditor || isLoadingDynamicData) return;
      if (!$mdPageConfirmPublish) {
        $mdPageConfirmPublish = $divContentHidden.children('#md-page-confirm-publish');
      }
      if (!_this.checkValidPage()) {
        _this.closePublish($mdPageConfirmPublish);
      }
      const generalForm = app.$store.getters['page/generalForm'];
      const _title = title ? title : generalForm.title;
      const _handle = handle ? handle : generalForm.handle;
      const _meta = meta ? meta : generalForm.description;
      const _saveType = saveType ? saveType : 'publish';
      const gType = gfFrameData.getPageType();

      app.$store.dispatch('common/trackEvent', { eventId: EDITOR_EVENT.PUBLISH_CLICKED });

      _this.hidePopupConfirmPublish();

      $mdPageConfirmPublish.find('.confirm_publish_loading_text').text('Publishing..');
      $mdPageConfirmPublish.find('.confirm_publish_loading').addClass('show');

      const dataPage = {
        title: _title,
        handle: _handle,
        meta: _meta,
      };
      if (window._webSocket && window._webSocket?.connection.readyState === 1) {
        dataPage.isUseSocket = true;
      }
      // Show popup that show publish progress
      _this.savePage(_saveType, undefined, dataPage, function (data) {
        _this.closePublish($mdPageConfirmPublish);

        // Show popup if having a big module greater than 230KB
        if (data) {
          let $module = $gryffEditor.find('#' + data);
          const _template = `<div class="md-confirm">
                <div class="!p-[16px] text-left text-[#212121] text-base font-medium border-b border-[#EEEEEE] flex items-center justify-between">Optimize your module size
                <div class="flex items-center justify-center cursor-pointer w-[24px] h-[24px] rounded-[3px] hover:bg-[#E5E5E5] close"><img src="/editor/static/icons/close-modal.svg" /></div>
                </div>
                <div class="!py-4 !px-5 text-left border-b border-[#EEEEEE] text-[#676767] text-sm font-normal">You're having a big module with size greater than 230 KB. You should optimize it first and try to publish again</div>
                  <div class="md-confirm-button flex justify-end !py-4 !pr-6">
                    <button class="cancel !m-0 hover:bg-[#DCDCDC] h-10 bg-white !border !border-dark-100 !mr-2 !rounded-[3px] text-[#212121] !font-medium cursor-pointer flex items-center !px-6 !flex !items-center !justify-center" data-action="cancel">Cancel</button>
                    <button class="confirm !m-0 h-10 !bg-primary-300 !text-white !border-none !font-medium !rounded-[3px] !px-6 hover:!bg-[#365DE5] cursor-pointer !flex !items-center !justify-center" data-action="yes">
                        Confirm
                    </button>
                  </div>
            </div>`;
          const $activeModal = jQuery('<div/>');
          $divContentHidden.append($activeModal);
          $activeModal.gfModalNew({
            header: '',
            footer: '',
            width: 600,
            height: 202,
            center: true,
            onContent: function ($content) {
              $content.html(_template);
            },
          });

          $activeModal.data('gfmodalnew').onShow();
          $activeModal
            .find('button[data-action="cancel"]')
            .off('click')
            .on('click', () => {
              $activeModal.data('gfmodalnew').onClose();
              $activeModal.remove();
            });

          $activeModal
            .find('.close')
            .off('click')
            .on('click', () => {
              $activeModal.data('gfmodalnew').onClose();
              $activeModal.remove();
            });

          $activeModal
            .find('button[data-action="yes"]')
            .off()
            .on('click', function (e) {
              $activeModal.data('gfmodalnew').onClose();
              $activeModal.remove();

              $gryffEditor.parents('html, body').animate(
                {
                  scrollTop: $module.offset().top - 80,
                },
                800,
              );
              if ($module.data('gfrow') != undefined) {
                $module.data('gfrow').showTool();
              } else if ($module.data('gfelement') != undefined) {
                $module.data('gfelement').showTool();
              } else if ($module.data('gfform') != undefined) {
                $module.data('gfform').showTool();
              } else if ($module.data('gfmodule') != undefined) {
                $module.data('gfmodule').showTool();
              } else if ($module.data('gfmodal') != undefined) {
                $module.data('gfmodal').showTool();
              } else if ($module.data('gfmodalnew') != undefined) {
                $module.data('gfmodalnew').showTool();
              } else if ($module.data('gftabs') != undefined) {
                $module.data('gftabs').showTool();
              } else if ($module.data('gfelement') != undefined) {
                $module.data('gfelement').showTool();
              } else if ($module.data('gfelement') != undefined) {
                $module.data('gfelement').showTool();
              }

              if ($module.data('gfmodule') != undefined) {
                $module.data('gfmodule').openModuleSettings();
              } else if ($module.data('gfrow') != undefined) {
                $module.data('gfrow').openRowSettings();
              } else if ($module.parent().data('gfrow') != undefined) {
                $module = $module.parent();
                $module.data('gfrow').openRowSettings();
              } else if ($module.data('gfelement') != undefined) {
                $module.data('gfelement').openElementSettings();
              }
            });

          return false;
        }

        const newValue = {
          title: dataPage.title,
          handle: dataPage.handle,
          description: dataPage.meta,
        };
        app.$store.commit('page/SET_DEFAULT_GENERAL_PAGE_SETTING', {
          newValue,
          pageType: gType,
          pageGID: gfFrameData.getPageId(),
        });

        // update editor link
        _this.updateEditorUrl(gType, dataPage);
      });

      // Add to gfCount
      const extraCount = {};
      if ($gryffEditor && $gryffEditor.data('gfcount') != undefined) {
        $gryffEditor.data('gfcount').add('run-publish', extraCount);
      }

      const publishedWithGs = app.$store.state['app']['pageInfo']['page']['publishedWithGs'];
      const linkedPresetId = app.$store.state['sidebar']['linkedPresetId'];
      if (linkedPresetId && !publishedWithGs) {
        app.$store.commit('app/UPDATE_PAGE_STATUS_PUBLISHED_GS', true);
      }
    };

    this.closePublish = function ($mdPageConfirmPublish) {
      if (!$mdPageConfirmPublish) {
        $mdPageConfirmPublish = $divContentHidden.children('#md-page-confirm-publish');
      }
      $mdPageConfirmPublish.find('.confirm_publish_loading_text').text('Success!');
      const $publishLoading = $mdPageConfirmPublish.find('.confirm_publish_loading');
      $publishLoading.addClass('success');
      $publishLoading.removeClass('show');
      $publishLoading.removeClass('success');
      $mdPageConfirmPublish.remove();
    };

    this.hidePopupConfirmPublish = function () {
      // Hide popup confirm publish
      const $mdPageConfirm = jQuery('#md-page-confirm-publish');
      if ($mdPageConfirm.length) {
        $mdPageConfirm.removeClass('show');
      }
    };

    // this.renderPopupProgress = function () {
    //     // disable preview tooltip
    //     let $gfViewTooltip = $divTopBar.find('#gf-view').data('gftooltipsnew');
    //     if ($gfViewTooltip != undefined) {
    //         $gfViewTooltip.stop();
    //     }
    //     // disable publish tooltip
    //     let $gfPublishTooltip = $divTopBar.find('#md-page-confirm-publish').data('gftooltipsnew');
    //     if ($gfPublishTooltip != undefined) {
    //         $gfPublishTooltip.stop();
    //     }

    //     const EL_ID = "md-publish-progress";
    //     if ($divContentHidden.find('#' + EL_ID).length > 0) {
    //         let $modalProgress = $divContentHidden.find('#' + EL_ID);
    //         $modalProgress.addClass('show');
    //         $modalProgress.find("#progress-publish").val(0);
    //         $modalProgress.find(".progress-message").text("");
    //     } else {
    //         $divContentHidden.append('<div id="' + EL_ID + '" class="show"></div>');
    //         var $modalProgress = $divContentHidden.children('#' + EL_ID);

    //         // // on click body close;
    //         // $modalProgress.off('mousedown.closeBody').on('mousedown.closeBody', function (e) {
    //         //     if (e.which != 3) {
    //         //         if ($(e.target).closest('.body_confirm_publish').length == 0) {
    //         //             $modalProgress.removeClass('show');
    //         //         }
    //         //     }
    //         // });

    //         var _template =
    //             '<div class="body_confirm_publish body-publish-progress">' +
    //                 '<h3>Publishing Page</h3>' +
    //                 '<progress class="progress-publish" id="progress-publish" min="0" max="100" value="0" step="1" />' +
    //                 '<p class="progress-message"></p>' +
    //             '</div>';

    //         $modalProgress.html(_template);
    //     }
    //     return false;
    // }

    this.saveToLocal = function (data) {
      if (typeof Storage !== 'undefined') {
        let arrayValue = [];
        const gemValue = localStorage.getItem('gemValue');
        if (gemValue) {
          arrayValue = JSON.parse(gemValue);
        }

        const gId = data.gId;
        const shop = data.shop;

        const key = 'gem_' + gId + '_' + shop;

        // Mã hóa;
        const _dataEncode = HELPER.base64UrlEncode(JSON.stringify(data));

        //save To local;
        if (arrayValue.length > 20) {
          localStorage.setItem(arrayValue[0], '');
          localStorage.setItem(arrayValue[1], '');
        }

        function saveLocal(arrayValue, key, _dataEncode) {
          try {
            const index = arrayValue.indexOf(key);
            if (index == -1) {
              arrayValue.push(key);
            }
            localStorage.setItem('gemValue', JSON.stringify(arrayValue));
            localStorage.setItem(key, _dataEncode);
            return true;
          } catch (err) {
            console.log(err);
            localStorage.setItem(arrayValue[0], '');
            localStorage.setItem(arrayValue[1], '');

            return saveLocal(arrayValue, key, _dataEncode);
          }
        }

        saveLocal(arrayValue, key, _dataEncode);
      }
      return false;
    };

    // Set link mowis cho page
    this.updateEditorUrl = function (type, data) {
      if (type == 'template-page' || type == 'template-article') {
        // Xử lý url;
        const _page = HELPER.toHandle(data.handle);

        // Change url window
        function getParameterByName(name, url) {
          if (!url) url = window.location.href;
          name = name.replace(/[\[\]]/g, '\\$&');
          const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
          if (!results) return null;
          if (!results[2]) return '';
          return decodeURIComponent(results[2].replace(/\+/g, ' '));
        }

        const shop = gfFrameData.getShopDomain();
        if (shop == undefined || shop == '') {
          var _handle = '/editor?id=4920016934&page=0000-test&shop=gempages.myshopify.com&type=template-page'; // local
          var urlViews = '//baokhanhstore.myshopify.com/pages/testing-pages-1';
        } else {
          var _handle = window.location.href;
          var urlViews = $divTopBar.find('#gf-view').attr('origin-href');
        }
        const _id = getParameterByName('id', _handle);
        const _shop = getParameterByName('shop', _handle);
        const _type = getParameterByName('type', _handle);

        // update editor link here
        window.history.pushState(
          {},
          '',
          '/editor?id=' + _id + '&page=' + _page + '&shop=' + _shop + '&type=' + _type + '',
        );

        // Change URL View;
        const arrayUrlViews = urlViews?.split('/') || [];
        let newUrlViews = '';
        for (var i = 0; i < arrayUrlViews.length - 1; i++) {
          newUrlViews += arrayUrlViews[i] + '/';
        }
        newUrlViews += _page;
        // $divTopBar.find('#gf-view').attr('href', newUrlViews);
        _this.setViewPageLink(newUrlViews);

        // Change name and url page info;
        app.$store.commit('page/SET_DEFAULT_PAGE_TITLE', data.title);
        // $divTopBar.find('#pageInfo .page-name').attr('href', newUrlViews);

        const $dataPage = $gfFrame.attr('data-page')?.split('/');
        let newDataPage = '';
        for (var i = 0; i < $dataPage.length - 1; i++) {
          newDataPage += $dataPage[i] + '/';
        }

        // SAVE to iframe;
        $gfFrame.attr('data-page', newDataPage + _page);
        $gfFrame.attr('data-title', data.title);
        $gfFrame.attr('data-handle', _page);
        $gfFrame.attr('data-meta', data.meta);
      } else {
        app.$store.commit('page/SET_DEFAULT_PAGE_TITLE', data.title);
        // SAVE to iframe;
        $gfFrame.attr('data-title', data.title);
      }

      return false;
    };

    this.getMetaFields = function () {
      // GET METAFIELDS FROM THE EDITOR
      const metafields = [];
      $gryffBody.find('[data-label="(P) Meta"]').each(function () {
        const metaKey =
          jQuery(this).children('.module').attr('data-meta') != 'auto'
            ? jQuery(this).children('.module').attr('data-meta')
            : jQuery(this).attr('data-id');

        const $product = jQuery(this).closest('[data-label="Product"]');
        if ($product.length > 0) {
          let productId = $product.children('.module').attr('data-pid');
          const productData = HELPER.searchProductInList(productId);

          productId = productData.id != 'auto' ? productData.id : productData.real_id;

          if (productData.metafields != undefined) {
            if (
              productData.metafields.gempages[metaKey] != undefined &&
              productData.metafields.gempages[metaKey + '_bk'] != undefined
            ) {
              let found = false;
              for (let j = 0; j < metafields.length; j++) {
                if (metafields[j].productId == productId) {
                  metafields[j].metafields.gempages[metaKey] = productData.metafields.gempages[metaKey];
                  metafields[j].metafields.gempages[metaKey + '_bk'] = productData.metafields.gempages[metaKey + '_bk'];

                  found = true;
                  break;
                }
              }

              if (!found) {
                const meta = {
                  gempages: {},
                };
                meta.gempages[metaKey] = productData.metafields.gempages[metaKey];
                meta.gempages[metaKey + '_bk'] = productData.metafields.gempages[metaKey + '_bk'];

                const field = {
                  productId: productId,
                  metafields: meta,
                };
                metafields.push(field);
              }
            }
          }
        }
      });

      return metafields;
    };

    this.initPageFonts = function () {
      if (window._pageFonts && window._pageFonts.length == 0) {
        window._pageFonts = [
          {
            googleName: 'inherit',
            styleName: 'Inherit',
            fontWeight: '',
          },
        ];
        window._themeFonts = ['inherit', 'default'];
        const _defaultFonts = [
          {
            googleName: 'ABeeZee',
            styleName: 'ABeeZee',
            fontWeight: '400',
          },
          {
            googleName: 'Abril+Fatface',
            styleName: 'Abril Fatface',
            fontWeight: '400',
          },
          {
            googleName: 'Acme',
            styleName: 'Acme',
            fontWeight: '400',
          },
          {
            googleName: 'Alegreya',
            styleName: 'Alegreya',
            fontWeight: '400,700',
          },
          {
            googleName: 'Alegreya+Sans',
            styleName: 'Alegreya Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Anton',
            styleName: 'Anton',
            fontWeight: '400',
          },
          {
            googleName: 'Arimo',
            styleName: 'Arimo',
            fontWeight: '400,700',
          },
          {
            googleName: 'Arizonia',
            styleName: 'Arizonia',
            fontWeight: '400',
          },
          {
            googleName: 'Arvo',
            styleName: 'Arvo',
            fontWeight: '400,700',
          },
          {
            googleName: 'Baloo+Bhaina',
            styleName: 'Baloo Bhaina',
            fontWeight: '400',
          },
          {
            googleName: 'Bitter',
            styleName: 'Bitter',
            fontWeight: '400,700',
          },
          {
            googleName: 'Cabin',
            styleName: 'Cabin',
            fontWeight: '400,700',
          },
          {
            googleName: 'Cherry+Swash',
            styleName: 'Cherry Swash',
            fontWeight: '400,700',
          },
          {
            googleName: 'Courgette',
            styleName: 'Courgette',
            fontWeight: '400',
          },
          {
            googleName: 'Crimson+Text',
            styleName: 'Crimson Text',
            fontWeight: '400,700',
          },
          {
            googleName: 'Diplomata+SC',
            styleName: 'Diplomata SC',
            fontWeight: '400',
          },
          {
            googleName: 'Domine',
            styleName: 'Domine',
            fontWeight: '400,700',
          },
          {
            googleName: 'Dosis',
            styleName: 'Dosis',
            fontWeight: '400,700',
          },
          {
            googleName: 'Exo',
            styleName: 'Exo',
            fontWeight: '400,700',
          },
          {
            googleName: 'Fira+Sans',
            styleName: 'Fira Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Fjalla+One',
            styleName: 'Fjalla One',
            fontWeight: '400',
          },
          {
            googleName: 'Gentium+Basic',
            styleName: 'Gentium Basic',
            fontWeight: '400,700',
          },
          {
            googleName: 'Grand+Hotel',
            styleName: 'Grand Hotel',
            fontWeight: '400',
          },
          {
            googleName: 'Gravitas+One',
            styleName: 'Gravitas One',
            fontWeight: '400',
          },
          {
            googleName: 'Inconsolata',
            styleName: 'Inconsolata',
            fontWeight: '400,700',
          },
          {
            googleName: 'Indie+Flower',
            styleName: 'Indie Flower',
            fontWeight: '400',
          },
          {
            googleName: 'Josefin+Sans',
            styleName: 'Josefin Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Karla',
            styleName: 'Karla',
            fontWeight: '400,700',
          },
          {
            googleName: 'Kreon',
            styleName: 'Kreon',
            fontWeight: '400,700',
          },
          {
            googleName: 'Krona+One',
            styleName: 'Krona One',
            fontWeight: '400',
          },
          {
            googleName: 'Lato',
            styleName: 'Lato',
            fontWeight: '400,700',
          },
          {
            googleName: 'League+Script',
            styleName: 'League Script',
            fontWeight: '400',
          },
          {
            googleName: 'Libre+Baskerville',
            styleName: 'Libre Baskerville',
            fontWeight: '400,700',
          },
          {
            googleName: 'Libre+Franklin',
            styleName: 'Libre Franklin',
            fontWeight: '400,700',
          },
          {
            googleName: 'Lobster',
            styleName: 'Lobster',
            fontWeight: '400',
          },
          {
            googleName: 'Lora',
            styleName: 'Lora',
            fontWeight: '400,700',
          },
          {
            googleName: 'Luckiest+Guy',
            styleName: 'Luckiest Guy',
            fontWeight: '400',
          },
          {
            googleName: 'Merriweather',
            styleName: 'Merriweather',
            fontWeight: '400,700',
          },
          {
            googleName: 'Montserrat',
            styleName: 'Montserrat',
            fontWeight: '400,700',
          },
          {
            googleName: 'Mrs+Sheppards',
            styleName: 'Mrs Sheppards',
            fontWeight: '400',
          },
          {
            googleName: 'Neuton',
            styleName: 'Neuton',
            fontWeight: '400,700',
          },
          {
            googleName: 'Niconne',
            styleName: 'Niconne',
            fontWeight: '400',
          },
          {
            googleName: 'Noto+Sans',
            styleName: 'Noto Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Nunito',
            styleName: 'Nunito',
            fontWeight: '400,700',
          },
          {
            googleName: 'Open+Sans',
            styleName: 'Open Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Oswald',
            styleName: 'Oswald',
            fontWeight: '400,700',
          },
          {
            googleName: 'Oxygen',
            styleName: 'Oxygen',
            fontWeight: '400,700',
          },
          {
            googleName: 'Pacifico',
            styleName: 'Pacifico',
            fontWeight: '400',
          },
          {
            googleName: 'Paytone+One',
            styleName: 'Paytone One',
            fontWeight: '400',
          },
          {
            googleName: 'Playball',
            styleName: 'Playball',
            fontWeight: '400',
          },
          {
            googleName: 'Playfair+Display',
            styleName: 'Playfair Display',
            fontWeight: '400,700',
          },
          {
            googleName: 'Poppins',
            styleName: 'Poppins',
            fontWeight: '400,700',
          },
          {
            googleName: 'PT+Mono',
            styleName: 'PT Mono',
            fontWeight: '400',
          },
          {
            googleName: 'PT+Sans',
            styleName: 'PT Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'PT+Serif',
            styleName: 'PT Serif',
            fontWeight: '400,700',
          },
          {
            googleName: 'Quattrocento+Sans',
            styleName: 'Quattrocento Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Qwigley',
            styleName: 'Qwigley',
            fontWeight: '400',
          },
          {
            googleName: 'Raleway',
            styleName: 'Raleway',
            fontWeight: '400,700',
          },
          {
            googleName: 'Roboto',
            styleName: 'Roboto',
            fontWeight: '400,700',
          },
          {
            googleName: 'Roboto+Condensed',
            styleName: 'Roboto Condensed',
            fontWeight: '400,700',
          },
          {
            googleName: 'Roboto+Slab',
            styleName: 'Roboto Slab',
            fontWeight: '400,700',
          },
          {
            googleName: 'Rokkitt',
            styleName: 'Rokkitt',
            fontWeight: '400,700',
          },
          {
            googleName: 'Sacramento',
            styleName: 'Sacramento',
            fontWeight: '400',
          },
          {
            googleName: 'Sail',
            styleName: 'Sail',
            fontWeight: '400',
          },
          {
            googleName: 'Sedgwick+Ave+Display',
            styleName: 'Sedgwick Ave Display',
            fontWeight: '400',
          },
          {
            googleName: 'Shadows+Into+Light',
            styleName: 'Shadows Into Light',
            fontWeight: '400',
          },
          {
            googleName: 'Sigmar+One',
            styleName: 'Sigmar One',
            fontWeight: '400',
          },
          {
            googleName: 'Six+Caps',
            styleName: 'Six Caps',
            fontWeight: '400',
          },
          {
            googleName: 'Slabo+27px',
            styleName: 'Slabo 27px',
            fontWeight: '400',
          },
          {
            googleName: 'Source+Code+Pro',
            styleName: 'Source Code Pro',
            fontWeight: '400,700',
          },
          {
            googleName: 'Stalemate',
            styleName: 'Stalemate',
            fontWeight: '400',
          },
          {
            googleName: 'Titillium+Web',
            styleName: 'Titillium Web',
            fontWeight: '400,700',
          },
          {
            googleName: 'Tulpen+One',
            styleName: 'Tulpen One',
            fontWeight: '400',
          },
          {
            googleName: 'Ubuntu',
            styleName: 'Ubuntu',
            fontWeight: '400,700',
          },
          {
            googleName: 'Ultra',
            styleName: 'Ultra',
            fontWeight: '400',
          },
          {
            googleName: 'Unica+One',
            styleName: 'Unica One',
            fontWeight: '400',
          },
          {
            googleName: 'Vollkorn',
            styleName: 'Vollkorn',
            fontWeight: '400,700',
          },
          {
            googleName: 'Work+Sans',
            styleName: 'Work Sans',
            fontWeight: '400,700',
          },
          {
            googleName: 'Yellowtail',
            styleName: 'Yellowtail',
            fontWeight: '400',
          },
        ];

        const addFonts = [];
        const addFontsByName = async function (googleName, custom) {
          if (googleName != undefined) {
            if (googleName.indexOf(':') != -1) {
              var fontWeight = googleName.split(':')[1];
            } else {
              var fontWeight = '';
            }

            googleName = googleName.split(':')[0];

            let styleName;
            if (jQuery(_defaultFonts[i]).attr('data-fonts')) {
              styleName = jQuery(_defaultFonts[i]).attr('data-fonts');
            } else {
              styleName = googleName;
            }
            styleName = styleName.replace(/\+/g, ' ');

            if (custom != undefined && custom) {
              var item = {
                googleName: googleName,
                styleName: styleName,
                fontWeight: fontWeight,
                custom: custom,
              };

              if (jQuery.inArray(item.googleName, window._themeFonts) == -1) {
                window._themeFonts.push(item.googleName);
              }
            } else {
              var item = {
                googleName: googleName,
                styleName: styleName,
                fontWeight: fontWeight,
                custom: false,
              };
            }

            // Check not import
            let fontCheck = styleName.toLowerCase();
            fontCheck = fontCheck.replace(' ', '');
            fontCheck = fontCheck.replace('-', '');
            let count = 0;
            for (let j = 0; j < window._pageFonts.length; j++) {
              let fontInit = window._pageFonts[j].styleName.toLowerCase();
              fontInit = fontInit.replace(' ', '');
              fontInit = fontInit.replace('-', '');

              // Check equal font;
              if (fontInit == fontCheck) {
                count++;
              }
              // Check font name;
              if (fontCheck == 'default') {
                count++;
              }
            }

            if (count == 0) {
              item.isActive = true;
              item.custom = true;
              addFonts.push(item);
            }
          }

          return false;
        };

        const gfFonts = $gfFrame.contents().find('head').find('link.gf_fonts');
        for (var i = 0; i < gfFonts.length; i++) {
          const googleName = jQuery(gfFonts[i]).attr('href').split('=')[1];

          if (!googleName || googleName.length > 1) {
            addFontsByName(googleName);
          }
        }

        const getActiveFontFromLocalStorage = async function (activeFontList) {
          try {
            const payload = {
              key: 'active-font',
              value: JSON.stringify(activeFontList),
            };
            await Api.base.post(shopmeta.base, payload);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log('saveActiveFontListError', error);
          }
          activeFontList.forEach((fontName) => {
            addFontsByName(fontName);
          });
          app.$store.dispatch('font/addFontOptions', addFonts);
          // remove list active forever
          const shop = gfFrameData.getShopDomain();
          localStorage.removeItem('gfFontList_' + shop);
        };

        const getActiveFontFromShopmeta = async function (activeFonts) {
          try {
            if (activeFonts) {
              const value = JSON.parse(activeFonts);
              value.forEach((fontName) => {
                addFontsByName(fontName);
              });
              app.$store.dispatch('font/addFontOptions', addFonts);
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.log('getActiveFontError', error);
          }
        };

        const initActiveAndOptionFonts = async function () {
          const fontMeta = app.$store.state['app']['fontMeta'];
          const { activeFonts, themeFonts, installedFonts } = fontMeta;
          const shop = gfFrameData.getShopDomain();
          if (localStorage && localStorage['gfFontList_' + shop]) {
            const fontList = JSON.parse(localStorage['gfFontList_' + shop]);
            await getActiveFontFromLocalStorage(fontList); // pass active font as param
          }
          await getActiveFontFromShopmeta(activeFonts); // pass active font as param
          app.$store.dispatch('font/addFontOptionsAndLoadGoogleFonts', {
            fonts: addFonts,
            needSave: true,
            fontMeta: fontMeta,
          });
        };

        initActiveAndOptionFonts();
      }
      return false;
    };

    this.isDupplicateElement = function () {
      let duplicateLabel = '';
      const hightlightIds = [];
      const pickyElements = [];
      const alireviewsV6 = [];
      const laiReviewExpress = [];
      $gryffEditor.find('[id^="m-"]').each(function () {
        const $element = jQuery(this);
        const label = $element.attr('data-label');
        switch (label) {
          case 'Product': {
            const $wSticker = $element.find('[data-widget="sticker"]');
            if ($wSticker && $wSticker.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wSticker.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wMessage = $element.find('[data-widget="message"]');
            if ($wMessage && $wMessage.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wMessage.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wGetItBuyTimer = $element.find('[data-widget="get-it-by-timer"]');
            if ($wGetItBuyTimer && $wGetItBuyTimer.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wGetItBuyTimer.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wBuyXGetY = $element.find('[data-widget="buy-x-get-y"]');
            if ($wBuyXGetY && $wBuyXGetY.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wBuyXGetY.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wCountdownTimer = $element.find('[data-widget="countdown-timer"]');
            if ($wCountdownTimer && $wCountdownTimer.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wCountdownTimer.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wStockInventoryNumber = $element.find('[data-widget="stock-inventory-number"]');
            if ($wStockInventoryNumber && $wStockInventoryNumber.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wStockInventoryNumber.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wTrustBadge = $element.find('[data-widget="trust-badge"]');
            if ($wTrustBadge && $wTrustBadge.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wTrustBadge.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            const $wAdvanceTrustBadge = $element.find('[data-widget="advanced-trust-badge"]');
            if ($wAdvanceTrustBadge && $wAdvanceTrustBadge.length > 1) {
              duplicateLabel = 'Ultimate Sales Boost';
              $wAdvanceTrustBadge.each(function () {
                const moduleId = jQuery(this).parent().attr('id');
                hightlightIds.push(moduleId);
              });
            }
            break;
          }
          case 'PickyStory': {
            pickyElements.push($element);
            break;
          }
          case 'Ali Reviews': {
            const aliVersion = $element.children('.module').attr('data-aliver');
            if (aliVersion === 'v6') {
              const aliModuleId = $element.attr('id');
              const aliSectionID = $element.children('.module').attr('data-aliid');
              alireviewsV6.push({ id: aliModuleId, dataID: aliSectionID });
            }
            break;
          }
          case 'LAI AliExpress Reviews': {
            laiReviewExpress.push($element);
            break;
          }
        }
      });
      if (pickyElements && pickyElements.length) {
        const $bundleStack = [],
          $kitStack = [],
          $bythelookStack = [],
          $galleryStack = [];
        pickyElements.forEach(($picky) => {
          const $pkBundle = $picky.find('[data-widget="gem-picky-bundle"]');
          const $pkKit = $picky.find('[data-widget="gem-picky-kit"]');
          const $pkByTheLook = $picky.find('[data-widget="gem-picky-buy-the-look"]');
          const $pkGallery = $picky.find('[data-widget="gem-picky-gallery"]');
          if ($pkBundle.length) {
            $bundleStack.push($pkBundle);
          }
          if ($pkKit.length) {
            $kitStack.push($pkKit);
          }
          if ($pkByTheLook.length) {
            $bythelookStack.push($pkByTheLook);
          }
          if ($pkGallery.length) {
            $galleryStack.push($pkGallery);
          }
        });

        if ($bundleStack && $bundleStack.length > 1) {
          duplicateLabel = 'PickyStory';
          $bundleStack.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }

        if ($kitStack && $kitStack.length > 1) {
          duplicateLabel = 'PickyStory';
          $kitStack.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }

        if ($bythelookStack && $bythelookStack.length > 1) {
          duplicateLabel = 'PickyStory';
          $bythelookStack.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }

        if ($galleryStack && $galleryStack.length > 1) {
          duplicateLabel = 'PickyStory';
          $pkGallery.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }
      }

      if (alireviewsV6 && alireviewsV6.length > 1) {
        const lookup = alireviewsV6.reduce((a, e) => {
          a[e.dataID] = ++a[e.dataID] || 0;
          return a;
        }, {});
        if (!jQuery.isEmptyObject(lookup)) {
          const result = alireviewsV6.filter((e) => lookup[e.dataID]);
          if (result && result.length) {
            duplicateLabel = 'Ali Reviews';
            result.forEach((res) => {
              if (res.dataID) {
                hightlightIds.push(res.id);
              }
            });
          }
        }
      }
      if (laiReviewExpress && laiReviewExpress.length > 1) {
        const $happySection = [],
          $homeSection = [],
          $productSection = [];
        laiReviewExpress.forEach(($lai) => {
          const $happySec = $lai.find('[data-widget="happy-page"]');
          const $homeSec = $lai.find('[data-widget="home-section"]');
          const $productSec = $lai.find('[data-widget="product-section"]');
          if ($happySec.length) {
            $happySection.push($happySec);
          }
          if ($homeSec.length) {
            $homeSection.push($homeSec);
          }
          if ($productSec.length) {
            $productSection.push($productSec);
          }
        });
        duplicateLabel = 'LAI AliExpress Reviews';
        if ($happySection && $happySection.length > 1) {
          $happySection.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }
        if ($homeSection && $homeSection.length > 1) {
          $homeSection.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }
        if ($productSection && $productSection.length > 1) {
          $productSection.forEach(($ele) => {
            const moduleId = $ele.parent().attr('id');
            hightlightIds.push(moduleId);
          });
        }
      }
      //fix two product filter search on a page
      const $key = $element.find('[data-key="product-filter-search"]');
      if ($key && $key.length > 1) {
        const hasOldLabel = $element.find('[data-label="Product Filter & Search"]')?.length > 0;
        const hasNewLabel = $element.find('[data-label="Boost AI Search & Discovery"]')?.length > 0;

        if (hasOldLabel && hasNewLabel) {
          duplicateLabel = 'Boost AI Search & Discovery (Product Filter & Search)';
        } else if (!hasOldLabel && hasNewLabel) {
          duplicateLabel = 'Boost AI Search & Discovery';
        } else if (hasOldLabel && !hasNewLabel) {
          duplicateLabel = 'Product Filter & Search';
        }

        $key.each(function () {
          const moduleId = jQuery(this).attr('id');
          hightlightIds.push(moduleId);
        });
      }
      // highlight process
      if (hightlightIds.length > 1) {
        const len = hightlightIds.length;
        hightlightIds.forEach((moduleId) => {
          const $usbModule = $gryffEditor.find('#' + moduleId);
          const $hightlightModule = $usbModule.find('.gf_uncompile-module-icon');
          $hightlightModule.addClass('gf_highlight_invalid');
        });

        const $lastUsbModule = $gryffEditor.find('#' + hightlightIds[len - 1]);
        $gryffEditor.parents('html, body').animate(
          {
            scrollTop: $lastUsbModule.offset().top - 80,
          },
          300,
        );
        setTimeout(() => {
          const $fistUsbModule = $gryffEditor.find('#' + hightlightIds[0]);
          $gryffEditor.parents('html, body').animate(
            {
              scrollTop: $fistUsbModule.offset().top - 80,
            },
            300,
          );
        }, 1000);

        setTimeout(() => {
          hightlightIds.forEach((moduleId) => {
            const $usbModule = $gryffEditor.find('#' + moduleId);
            const $hightlightModule = $usbModule.find('.gf_uncompile-module-icon');
            $hightlightModule.removeClass('gf_highlight_invalid');
          });
        }, 2000);
        if (
          [
            'Product Filter & Search',
            'Boost AI Search & Discovery',
            'Boost AI Search & Discovery (Product Filter & Search)',
          ].includes(duplicateLabel)
        ) {
          HELPER.showNotify(`${duplicateLabel} element can only be used once per page.`, 'error', 3000);
        } else {
          HELPER.showNotify(`Each widget type of ${duplicateLabel} can be used once on a page.`, 'error', 3000);
        }
      }
      return hightlightIds;
    };

    this.checkValidPage = function () {
      let result = true;
      const invalidElements = _this.isDupplicateElement() || [];
      if (invalidElements && invalidElements.length > 0) {
        result = false;
      }
      return result;
    };

    this.savePage = function (saveType, $publishBtn, dataPage, callback, notification) {
      app.$store.commit('page/RESET_COUNT_PRODUCT_DYNAMIC');
      app.$store.commit('page/UPDATE_IS_USED_PRELOAD_PRODUCT_SNIPPET', false);

      const pageValid = _this.checkValidPage();

      const gfFrame = document.getElementById('gfFrame');
      const gfFrameDoc = gfFrame.contentDocument || gfFrame.contentWindow.document;
      const gfFrameDocNotChange = gfFrameDoc.getElementsByTagName('html')[0].innerHTML;

      if (!pageValid) {
        return;
      }
      if (saveType === 'save') {
        HELPER.disabledAllAction();
        const saveBtnTemplate = HELPER.getLoading3DotTemplate('Saving');
        jQuery('.gf-save-btn').html(saveBtnTemplate);
      }

      const $gfPublishBtn = jQuery('.gf-publish-btn');
      // Show Loading on Publish button
      if (saveType === 'publish') {
        const publishBtnTemplate = HELPER.getLoading3DotTemplate('Publishing');
        var oldPublishBtnTemplate = $gfPublishBtn.html();
        $gfPublishBtn.html(publishBtnTemplate);
        HELPER.disabledAllAction();
        // Start the A/B campaign lookup now so the publish tooltip, shown once this save finishes,
        // knows whether this page already has a campaign. Refetched every publish: one can be
        // created from the tooltip link itself between two publishes.
        fetchTemplateCampaign({ force: true });
        if (isInIframe()) {
          postMessageToParent({ type: 'saveDone' });
        }
      }

      // gia lap de tao cam giac save nhanh hon
      if (notification == undefined) {
        notification = true;
      }

      if (dataPage == undefined) {
        const generalForm = app.$store.getters['page/generalForm'];
        dataPage = {
          title: generalForm.title,
          handle: generalForm.handle,
          meta: generalForm.description,
        };
      }

      setTimeout(function () {
        const gId = gfFrameData.getPageId();
        const gType = gfFrameData.getPageType();
        var shop = gfFrameData.getShopDomain();

        switch (saveType) {
          case 'save':
            var gTitle = dataPage.title;
            var gHandle = dataPage.handle;
            var gMeta = dataPage.meta;
            break;

          case 'publish':
            var gTitle = dataPage.title;
            var gHandle = dataPage.handle;
            var gMeta = dataPage.meta;
            break;

          case 'make_default':
            var gTitle = dataPage.title;
            var gHandle = dataPage.handle;
            var gMeta = dataPage.meta;
            var gDefault = dataPage.default;
            break;
        }

        // LAZYLOADING2019
        const advanceForm = app.$store.getters['page/advanceForm'];
        const lazyload = advanceForm.lazyLoad;

        const switcher = jQuery('.confirm_publish .lazy-load-option #switch-shadow').data('gfswitcher');
        if (switcher != undefined) {
          switcher.onChangeValue(lazyload);
        }

        // GET METAFIELDS FROM THE EDITOR
        const metafields = _this.getMetaFields();
        let data = $gryffEditor.data('gryffeditor').getEditorContent();

        if (data.bkHtml.includes('(P) Swatches')) {
          const replacements = [
            {
              regex: /(data-background="{{swatcherv1}}")(?!.*data-gp-product-handle="{{product\.handle}}")/g,
              replacement: '$1 data-gp-product-handle="{{product.handle}}"',
            },
            {
              regex: /(data-value="{{value \| escape}}")(?!.*data-gp-option-value-id="{{value\.id \| json}}")/g,
              replacement: '$1 data-gp-option-value-id="{{value.id | json}}"',
            },
          ];

          replacements.forEach(({ regex, replacement }) => {
            data.bkHtml = data.bkHtml.replaceAll(regex, replacement);
          });
        }

        if (saveType === 'publish') {
          const splitCheck = HELPER.canSplitContent(data.html);
          if (!splitCheck.status) {
            setTimeout(function () {
              if (callback) {
                callback(splitCheck.id);
              }
            }, 1000);

            jQuery('.gf-publish-btn').html(oldPublishBtnTemplate);
            const pageType = gfFrameData.getPageType();
            let enabledViewlive = true;
            let enabledPreview = true;
            if (pageType == 'template-product') {
              const totalAssigned = app.$store.state['page']['assignedProduct']['list'].length;
              enabledViewlive = enabledViewlive && totalAssigned;

              enabledPreview = !!$divTopBar.find('#gf-preview').attr('href');
            }

            HELPER.enabledAllAction(enabledViewlive, enabledPreview);
            return false;
          }
        }

        let listLib = [];
        for (let i = 0; i < data.libs.length; i++) {
          if (shop === 'folklore-surf.myshopify.com' && data.libs[i] === 'https://player.vimeo.com/api/player.js') {
            continue;
          }
          if (jQuery.inArray(data.libs[i], listLib) === -1) {
            listLib.push(data.libs[i]);
          }
        }

        // LAZYLOADING2019
        if (lazyload) {
          listLib.push('https://assets.gemcommerce.com/v6/libs/js/gfv2lazyload.js');
          data.script += `
                          (function( jQuery ){
                              try{
                                  if(jQuery().gfV2Lazyload){
                                      var $module = jQuery(window);
                                      $module.gfV2Lazyload({delay:125})
                                  }
                              }catch(err){
                                  console.error(err)
                              }
                          })( window.GemQuery || jQuery );
                      `;
          data.style += '.gf_lazyload{filter:blur(5px);transition:filter .3s}.gf_lazyloaded{filter:initial}';
        }

        let actionsScript = '';

        const actionsStore = app.$store.getters['editor/GET_ANIMATION_DATA']('action');
        const interactionStore = app.$store.getters['editor/GET_ANIMATION_DATA']('interaction');

        for (const key in interactionStore) {
          let interactionData = {};
          try {
            interactionData = JSON.parse(interactionStore[key]);
          } catch (error) {
            interactionData = {};
          }
          if (interactionData && interactionData.animations && interactionData.animations.length) {
            listLib.push('https://assets.gemcommerce.com/v6/libs/js/gfv1animate.js');
            listLib.push('https://assets.gemcommerce.com/v6/libs/css/gfv1animate.min.css');
            break;
          }
        }

        for (const key in actionsStore) {
          if (actionsStore[key] == '[]') continue;

          actionsScript += `window.__gfFlowActions.push(${actionsStore[key]});`;

          //add style
          const flowActionsData = JSON.parse(actionsStore[key]);
          data.style += getStyleFromActionItems(flowActionsData);
        }
        // Load animate libs if atom use animate
        if (actionsScript) {
          data.script += `window.__gfFlowActions = []; ${actionsScript} window.__gfV1FlowActions.init();`;
          //check exist animate
          if (!listLib.includes('https://assets.gemcommerce.com/v6/libs/js/gfv1animate.js')) {
            listLib.push('https://assets.gemcommerce.com/v6/libs/js/gfv1animate.js');
            listLib.push('https://assets.gemcommerce.com/v6/libs/css/gfv1animate.min.css');
          }
          listLib.push(
            import.meta.env.VITE_APP_FLOW_ACTION_LIB || 'https://assets.gemcommerce.com/v6/libs/js/gfv1flowactions.js',
          );
        }

        // console.log('---------------------- PAGE SAVE HTML ------------------------');
        // console.log(data.html);
        // console.log('-------------------------- BK HTML --------------------------');
        // console.log(data.bkHtml);
        // console.log('-------------------------- STYLE --------------------------');
        // console.log(data.style);
        // console.log('-------------------------- SCRIPT --------------------------');
        // console.log(data.script);
        // console.log('-------------------------- ListLIB --------------------------');
        // console.log(listLib);
        //
        // console.log('-------------------------- FONTS --------------------------');
        // console.log(data.fonts);
        // console.log('-------------------------- META --------------------------');
        // console.log(JSON.stringify(metafields));
        // console.log('---------------------- END SAVE ------------------------');

        var shop = gfFrameData.getShopDomain();

        // Fix case import old template/block that include old libs
        if (data.bkHtml && data.bkHtml.includes('d1sdh98c392aqd.cloudfront.net')) {
          const regexUrl = /d1sdh98c392aqd.cloudfront.net/g;
          data.bkHtml = data.bkHtml.replace(regexUrl, 'assets.gemcommerce.com/v6');
          for (let index = 0; index < listLib.length; index++) {
            listLib[index] = listLib[index].replace(regexUrl, 'assets.gemcommerce.com/v6');
          }
        }

        // Vue3+vite+buildClientV1: Replace cloudfront with cloudfront ENV
        if (data.bkHtml && data.bkHtml.includes('d1um8515vdn9kb.cloudfront.net')) {
          const regexUrl = /d1um8515vdn9kb.cloudfront.net/g;
          data.bkHtml = data.bkHtml.replace(regexUrl, 'assets.gemcommerce.com/v6');
          for (let index = 0; index < listLib.length; index++) {
            if (listLib[index]) {
              listLib[index] = listLib[index].replace(regexUrl, 'assets.gemcommerce.com/v6');
            }
          }
        }

        // Filter duplicate lib in array
        const tempLibs = listLib.filter(function (item, pos) {
          return listLib.indexOf(item) == pos;
        });

        listLib = tempLibs;

        // ===== GemMeter Feature ===== //
        if (data.bkHtml && data.bkHtml.includes(ACTIVE_CLASSES)) {
          data.bkHtml = data.bkHtml.replaceAll(ACTIVE_CLASSES, '');
        }
        if (data.html && data.html.includes(ACTIVE_CLASSES)) {
          data.html = data.html.replaceAll(ACTIVE_CLASSES, '');
        }
        // =========================== //

        if (gType != '') {
          const _dataLocal = {
            shop: shop,
            gId: gId,
            gTitle: gTitle,
            gContent: data.html,
            gBkContent: data.bkHtml,
          };

          data = {
            shop: shop,
            gId: gId,
            gTitle: gTitle,
            gHandle: gHandle,
            gMeta: gMeta,
            gType: gType,
            gContent: data.html,
            gBkContent: data.bkHtml,
            gStyle: data.style,
            gScript: data.script,
            libs: listLib,
            fonts: data.fonts,
            metafields: JSON.stringify(metafields),
            mailchimpData: JSON.stringify(window._mailchimpData),
            saveType: saveType,
            lazyload: lazyload,
          };

          // This flag will make this page save/pubish without update the updated_at field
          if (window.gemForceUpdate && window.gemForceUpdate == true) {
            data['forceUpdate'] = 1;
          }

          if (checkKeyValid('trackingError')) {
            if (window.trackingError && window.trackingError.length > 0) {
              data.trackingError = gfFrameDocNotChange + JSON.stringify(window.trackingError);
            }
          }

          let isNotSocket = true;
          // Send socketID if socket initialized
          if (dataPage && dataPage.isUseSocket) {
            data.isUseSocket = dataPage.isUseSocket;
            isNotSocket = false;
          }

          if (saveType == 'make_default') {
            data.gDefault = gDefault;
          }

          if (gType == 'template-product') {
            let productDynamic = getDynamicProduct('id, title, handle');
            if (!productDynamic.id) {
              productDynamic = app.$store.getters['page/GET_PRODUCT_DYNAMIC'];
            }
            data.product = productDynamic;
          }

          data.extras = {};
          const isInitPreloadSnippetProduct = app.$store.getters['page/GET_IS_INIT_PRELOAD_PRODUCT_SNIPPET'];
          const isUsedPreloadSnippetProduct = app.$store.getters['page/GET_IS_USED_PRELOAD_PRODUCT_SNIPPET'];
          const countProductDynamic = app.$store.getters['page/GET_COUNT_PRODUCT_DYNAMIC'];
          if (isInitPreloadSnippetProduct) {
            data.extras['isCreatedPreAddedProduct'] = true;
          }
          data.extras['isUsedPreAddedProduct'] = isUsedPreloadSnippetProduct;
          data.extras['countProductDynamic'] = countProductDynamic;

          setTimeout(function () {
            if (callback) {
              callback();
            }
          }, 1000);
          let isNotSession = false;

          const req = api.savePage();

          const socketData = {
            TIMEOUT: 120000,
            INTERVAL: 33,
            percentage: 0,
            timeout: -1,
            totalSteps: 4,
            currentStep: 0,
          };

          function onUnauthorized() {
            // eslint-disable-next-line no-inner-declarations
            function createSession(url, w, h, callback) {
              const dualScreenLeft = window.screenLeft != undefined ? window.screenLeft : window.screenX;
              const dualScreenTop = window.screenTop != undefined ? window.screenTop : window.screenY;

              const width = window.innerWidth
                ? window.innerWidth
                : document.documentElement.clientWidth
                ? document.documentElement.clientWidth
                : screen.width;
              const height = window.innerHeight
                ? window.innerHeight
                : document.documentElement.clientHeight
                ? document.documentElement.clientHeight
                : screen.height;

              const left = width / 2 - w / 2 + dualScreenLeft;
              const top = height / 2 - h / 2 + dualScreenTop;

              const _template = `<div class="md-confirm rounded">
                  <div class="!py-[18px] text-left !pl-4 text-[#212121] text-base font-medium border-b border-[#EEEEEE] flex items-center justify-between">Session has expired.
                  <div class="flex items-center justify-center cursor-pointer w-[20px] h-[20px] hover:bg-[#E5E5E5] close !mr-3"><img src="/editor/static/icons/close-modal.svg" /></div>
                  </div>
                  <div class="!py-4 !px-5 text-left border-b border-[#EEEEEE] text-[#676767] text-sm font-normal">We will help you to initialize new session. Please click <strong>Agree</strong> to continue.</div>
                  <div class="md-confirm-button flex justify-end !py-4 !pr-6">
                    <button class="hover:bg-[#E5E5E5] h-10 bg-white !border !border-dark-100 !mr-2 rounded-sm text-[#212121] font-medium flex items-center !px-6" data-action="cancel">Cancel</button>
                    <button class="h-10 !bg-primary-300 !text-white !border-none font-medium rounded-sm !px-6 hover:!bg-[#6385FF]" data-action="yes">
                      Agree
                    </button>
                  </div>
                </div>`;
              const $activeModal = jQuery('<div/>');
              $divContentHidden.append($activeModal);
              $activeModal.gfModalNew({
                header: '',
                footer: '',
                width: 600,
                minHeight: '186px',
                center: true,
                onContent: function ($content) {
                  $content.html(_template);
                },
              });

              $activeModal.data('gfmodalnew').onShow();

              $activeModal
                .find('button[data-action="yes"]')
                .off()
                .on('click', function (e) {
                  $activeModal.data('gfmodalnew').onClose();
                  $activeModal.remove();

                  const newWindow = window.open(url, '_blank');

                  if (window.focus) {
                    if (newWindow == null || typeof newWindow == 'undefined') {
                      alert(
                        'It seems there are errors occurred. Please disable your pop-up blocker and click the "Open" link again.',
                      );
                      // Remove lock save
                      if (saveType == 'save') {
                        $divTopBar.find('#gf-save').removeAttr('lock');
                        $divTopBar.find('#gf-preview').removeAttr('loading');
                        $divTopBar.find('#gf-preview span').text('Preview');
                      }
                    } else {
                      newWindow.focus();
                      newWindow.onload = function () {
                        newWindow.close();

                        // OPEN editor
                        const urlEditor = window.location.href;
                        const $iframeEditor = jQuery('<iframe src="' + urlEditor + '"></iframe>');
                        jQuery('body').append($iframeEditor);

                        app.$store.commit('page/SET_FRAME_LOADING_MESSAGE', 'Creating session');
                        app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', true);

                        $iframeEditor.on('load', function () {
                          const $contentIframe = jQuery($iframeEditor.contents());
                          const csrf = $contentIframe.find('meta[name="csrf-token"]').attr('content');

                          jQuery('meta[name="csrf-token"]').attr('content', csrf);

                          app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);

                          $iframeEditor.remove();
                          setTimeout(function () {
                            return callback();
                          }, 100);
                        });
                      };
                      // Event close poup
                      var popupTick = setInterval(function () {
                        if (newWindow.closed) {
                          clearInterval(popupTick);
                          // Remove lock save
                          if (saveType == 'save') {
                            $divTopBar.find('#gf-save').removeAttr('lock');
                            $divTopBar.find('#gf-preview').removeAttr('loading');
                            $divTopBar.find('#gf-preview span').text('Preview');
                          }
                        }
                      }, 500);
                    }
                  }
                  return false;
                });
              $activeModal
                .find('button[data-action="cancel"], .close')
                .off()
                .on('click', function (e) {
                  $activeModal.data('gfmodalnew').onClose();
                  $activeModal.remove();
                  // Remove lock save
                  if (saveType == 'save') {
                    $divTopBar.find('#gf-save').removeAttr('lock');
                    $divTopBar.find('#gf-preview').removeAttr('loading');
                    $divTopBar.find('#gf-preview span').text('Preview');
                  }
                  return false;
                });
            }

            const shop = gfFrameData.getShopDomain();
            if (shop == undefined || shop == '') {
              var sessionUrl = 'http://localhost:8000/session.html';
            } else {
              const apiDomain = config.serverDomain();
              var sessionUrl = apiDomain + '/login?shop=' + shop;
            }

            createSession(sessionUrl, 800, 600, function () {
              const _template = `<div class="md-confirm rounded">
                  <div class="!py-[18px] text-left !pl-4 text-[#212121] text-base font-medium border-b border-[#EEEEEE] flex items-center justify-between">Your content has not saved yet.
                  <div class="flex items-center justify-center cursor-pointer w-[20px] h-[20px] hover:bg-[#E5E5E5] close !mr-3"><img src="/editor/static/icons/close-modal.svg" /></div>
                  </div>
                  <div class="!py-4 !px-5 text-left border-b border-[#EEEEEE] text-[#676767] text-sm font-normal">It seems there are errors occurred. Please try to click on Save button one more time again. Thank you!</div>
                  <div class="md-confirm-button flex justify-end !py-4 !pr-6">
                    <button class="hover:bg-[#E5E5E5] h-10 bg-white !border !border-dark-100 !mr-2 rounded-sm text-[#212121] font-medium flex items-center !px-6" data-action="cancel">Cancel</button>
                    <button class="h-10 !bg-primary-300 !text-white !border-none font-medium rounded-sm !px-6 hover:!bg-[#6385FF]" data-action="yes">
                      Ok save again
                    </button>
                  </div>
                </div>`;

              const $activeModal = jQuery('<div/>');
              $divContentHidden.append($activeModal);
              $activeModal.gfModalNew({
                header: '',
                footer: '',
                width: 600,
                center: true,
                onContent: function ($content) {
                  $content.html(_template);
                },
              });

              $activeModal.data('gfmodalnew').onShow();

              $activeModal
                .find('button[data-action="yes"]')
                .off()
                .on('click', function (e) {
                  $activeModal.data('gfmodalnew').onClose();
                  $activeModal.remove();
                  //Lock save page;.
                  if (saveType == 'save') {
                    $divTopBar.find('#gf-save').addClass('gf-disabled_action');
                    $divTopBar.find('#gf-preview').addClass('gf-disabled_action');
                    const saveBtnTemplate = HELPER.getLoading3DotTemplate('Saving');
                    jQuery('.gf-save-btn').html(saveBtnTemplate);
                    $divTopBar.find('#gf-preview').on('click.lock', function (e) {
                      e.preventDefault();
                    });
                  }
                  isNotSession = true;
                  ajaxSaveToServer();
                  return false;
                });
              $activeModal
                .find('button[data-action="cancel"], .close')
                .off()
                .on('click', function (e) {
                  $activeModal.data('gfmodalnew').onClose();
                  $activeModal.remove();
                  // Remove lock save
                  if (saveType == 'save') {
                    $divTopBar.find('#gf-save').removeAttr('lock');
                    $divTopBar.find('#gf-preview').removeAttr('loading');
                    $divTopBar.find('#gf-preview span').text('Preview');
                  }
                  return false;
                });
            });
          }

          function ajaxSaveToServer() {
            // /* disabled button và bắt đầu chạy số đếm */
            // if (saveType == 'publish') {
            //     var timeCounter = setInterval(counterFc, 1000);
            //     function counterFc() {
            //         publishCounter++;
            //         // dừng chạy số đếm
            //         if (publishCounter == 60 || _this.isSendDone){
            //             var publishBtnTemplate = HELPER.getDefaultPublishButtonTemplate();
            //             jQuery('.gf-publish-btn').html(publishBtnTemplate);
            //             HELPER.enabledAllAction();
            //             clearInterval(timeCounter);
            //         }
            //         if(publishCounter > 60){
            //             HELPER.showNotify('There are some errors occurred please try again.', 'error');
            //             _this.isSendDone=true;
            //             /* Đặt lại trạng thái ban đầu của button publish */
            //             clearInterval(publishCounter);
            //             // eslint-disable-next-line no-redeclare
            //             var publishBtnTemplate =HELPER.getDefaultPublishButtonTemplate();
            //             jQuery('.gf-publish-btn').html(publishBtnTemplate);
            //             HELPER.enabledAllAction();
            //             publishCounter=0;

            //         }
            //     }
            // }
            // publishCounter=0;

            function onComplete(showTooltip = true) {
              _this.isSendDone = true;
              /* Đặt lại trạng thái ban đầu của button publish */
              const pageType = gfFrameData.getPageType();
              let enabledViewlive = true;
              let enabledPreview = true;
              if (pageType == 'template-product') {
                const totalAssigned = app.$store.state['page']['assignedProduct']['list'].length;
                enabledViewlive = enabledViewlive && totalAssigned;

                enabledPreview = !!$divTopBar.find('#gf-preview').attr('href');
              }

              if (saveType == 'publish') {
                // ===== GemMeter Feature ===== //
                emitter.emit('gem-meter:trigger-rules', GEM_METER_TRIGGER_EVENT.SAVE_PAGE);
                // ===== GemMeter Feature ===== //
                clearInterval(publishCounter);
                jQuery('.gf-publish-btn').html(oldPublishBtnTemplate);
                $publishButton.find('.progress-bar').remove();
                publishCounter = 0;
                if (showTooltip) {
                  setTimeout(() => {
                    _this.showToolTipsPublish();
                  }, 20);
                }
              }
              if (saveType == 'save') {
                const saveBtnTemplate = '<span>Save</span>';
                jQuery('.gf-save-btn').html(saveBtnTemplate);
                jQuery('#gf-save').removeClass('gf-disabled_action');
                enabledViewlive = enabledViewlive && app.$store.state['app']['pageInfo']['page']['isPublished'];
              }
              HELPER.enabledAllAction(enabledViewlive, enabledPreview);
              const productDynamic = app.$store.getters['page/GET_PRODUCT_DYNAMIC'];
              if (productDynamic && productDynamic.handle) {
                HELPER.setPreviewViewUrl(productDynamic.handle);
              }

              _this.sendUsageToServer();
            }

            function onError(xhr, status, error) {
              const responseJSON = xhr && xhr.responseJSON;
              if (
                (status == 'error' && error == 'Unauthorized') ||
                (responseJSON && responseJSON.code == 'apC00000' && responseJSON.message == 'sessionExpired')
              ) {
                onUnauthorized();
              }

              // Remove lock save
              if (saveType == 'save') {
                $divTopBar.find('#gf-save').removeClass('gf-disabled_action');
                $divTopBar.find('#gf-preview').removeAttr('loading');
                $divTopBar.find('#gf-preview span').text('Preview');
              }

              $publishButton.find('.progress-bar').remove();
              $publishButton.removeClass('publishing');

              Sentry.withScope((scope) => {
                scope.setLevel('error');
                scope.setExtra('data', {
                  responseJSON: JSON.stringify(responseJSON),
                  error: error,
                  errorStr: JSON.stringify(error),
                });
                Sentry.captureMessage(`Save/Publish error`);
              });
              HELPER.showNotify(
                `Failed to save data due to technical issues. Please <a onclick="Intercom('showNewMessage', 'Failed to save data due to technical issues')" class="text-blue-300 font-semibold cursor-pointer">ask our support</a> for further assistance..`,
                'error',
              );
              _this.isSendDone = true;
              /* Đặt lại trạng thái ban đầu của button publish */
              if (saveType == 'publish') {
                clearInterval(publishCounter);
                jQuery('.gf-publish-btn').html(oldPublishBtnTemplate);
                const pageType = gfFrameData.getPageType();
                let enabledViewlive = true;
                let enabledPreview = true;
                if (pageType == 'template-product') {
                  const totalAssigned = app.$store.state['page']['assignedProduct']['list'].length;
                  enabledViewlive = enabledViewlive && totalAssigned;
                  enabledPreview = !!$divTopBar.find('#gf-preview').attr('href');
                }
                HELPER.enabledAllAction(enabledViewlive, enabledPreview);
                publishCounter = 0;
              }
              if (saveType == 'save') {
                const saveBtnTemplate = '<span>Save</span>';
                jQuery('.gf-save-btn').html(saveBtnTemplate);
                jQuery('#gf-save').removeClass('gf-disabled_action');
              }
              onComplete(false);
            }

            function onSaveSuccess(showTooltip = true) {
              // ===== GemMeter Feature ===== //
              if (isLandingPage()) {
                emitTrackCompleteRateEvent(saveType);
              }

              // Remove lock save
              if (saveType == 'save') {
                $divTopBar.find('#gf-save').removeAttr('lock');
                $divTopBar.find('#gf-preview').removeAttr('loading');
                $divTopBar.find('#gf-preview span').text('Preview');
              }

              store.setValue('__isSaved', true);

              if (isNotSession) {
                if (saveType == 'publish') {
                  HELPER.showNotify('Data published successfully.', 'success');
                  // HELPER.showNotify('Data published successfully. It may take few seconds to update...', 'success');
                } else {
                  HELPER.showNotify('Data saved successfully.', 'success', 3000);
                }
              }

              if (notification) {
                if (saveType != 'publish') {
                  HELPER.showNotify(messageSaveSuccess.message, 'success', messageSaveSuccess.duration);
                  messageSaveSuccess = {
                    message: 'Data saved Successfully.',
                    duration: 3000,
                  };
                }
              }

              if ($publishBtn && ($publishBtn.hasClass('gf-upgrade-btn') || $publishBtn.hasClass('gf-update-btn'))) {
                try {
                  const href = $publishBtn.attr('href');
                  localStorage.setItem('gpPreviousUrl', href);
                  window.location.href = href;
                } catch (error) {
                  // console.log(error);
                }
                return false;
              }

              onComplete(showTooltip);
            }

            // TODO: Open progress box
            const $publishButton = $divTopBar.find('#gfActions #gf-publish');
            let $progressBar = $publishButton.find('.progress-bar');
            if (saveType == 'publish') {
              if (window._webSocket && window._webSocket.connection.readyState === 1) {
                $publishButton.removeClass('publishing').addClass('publishing');
              }

              $publishButton.append(`<div class="progress-bar"></div>`);
              $progressBar = $publishButton.find('.progress-bar');
            }
            // const $modalProgress = $divContentHidden.find("#md-publish-progress");
            // const $progressBar = $modalProgress.find("#progress-publish");
            // const $progressMessage = $modalProgress.find(".progress-message");

            const beforeSend = (xhr) => {
              xhr.setRequestHeader('X-CSRF-Token', jQuery('meta[name="csrf-token"]').attr('content'));
            };

            const pageInfoData = app.$store.getters['app/pageInfoData'];
            if (pageInfoData && !pageInfoData.contentPageAppliedGs) {
              data.contentPageAppliedGs = app.$store.getters['sidebar/GET_APPLIED_GS_FOR_PAGE'];
            }

            // ===== GemMeter Feature ===== //
            if (isLandingPage()) {
              const storeData = __cloneDeep(storeX.state.gemMeter);

              let pageRules = [...storeData.pageRules];
              const weakSEO = pageRules.find((item) => item.id === CHECK_LIST.WEAK_SEO.id);
              if (!weakSEO && saveType == PAGE_ACTIONS.PUBLISH) {
                pageRules = pageRules.concat(CHECK_LIST.WEAK_SEO);
              }

              if (Object.keys(storeData.elementsOfRules).length > 0) {
                data.gRecommendations = JSON.stringify({
                  convertableStandards: storeData.convertableStandards,
                  shopableStandards: storeData.shopableStandards,
                  elementGroups: storeData.elementGroups,
                  elementsOfRules: storeData.elementsOfRules,
                  inconsistentData: storeData.initializeStatus,
                  initializeStatus: storeData.initializeStatus,
                  isInitialize: storeData.isInitialize,
                  metric: storeData.metric,
                  pageElements: storeData.pageElements,
                  pageRules: pageRules,
                  version: storeData.version,
                });
              } else {
                data.gRecommendations = null;
              }
            }
            // =========================== //

            data.gContent = data.gContent
              .replaceAll('gf-outline-show', '')
              .replaceAll('gf-tool-show', '')
              .replaceAll('gf-highlight-display', '');
            POST(api.savePage().url, data, undefined, undefined, undefined, beforeSend)
              .then((res) => {
                const jsonData = res;
                // Error state
                if (jsonData.status == 'error') {
                  // trường hợp gặp lỗi khi sử dụng code Liquid
                  if (jsonData.code && jsonData.code == 'apC00001') {
                    // set giá trị mặc định. nếu không nhận được jsonData.message từ response thì sẽ hiển thị giá trị mặc định này
                    let liquidErrorMessage = 'Asset Liquid syntax error, Please try again later. Error_code: apC00001.';
                    if (jsonData.message) {
                      //trường hợp nhận được jsonData.message và hiển thị hết message nhận được từ backen
                      liquidErrorMessage = jsonData.message;
                    }
                    HELPER.showNotify(liquidErrorMessage, 'error');
                    return false;
                  } else if (jsonData.code && jsonData.code == 'apC00000') {
                    //unauthorized (code này cũ. có remove sau tháng 6/2021 :D)
                    onUnauthorized();
                  } else {
                    //các trường hợp còn lại
                    if (notification) {
                      HELPER.showNotify('Publish page failed, please try again later.', 'error');
                      return false;
                    }
                  }
                } else {
                  app.$store.commit('app/UPDATE_PAGE_STATUS_APPLIED_GS', true);
                  if (saveType == 'publish') {
                    if (isNotSocket) {
                      HELPER.showNotify('Data published Successfully.', 'success');
                      store.setValue('__isPublished', true);
                      app.$store.commit('app/UPDATE_PAGE_IS_PUBLISHED', true);

                      const pageInfo = store.getValue('__page');
                      const pageId = pageInfo.page.g_id;
                      const listPageIdString = localStorage.getItem('updateSettingList');
                      const listPageId = listPageIdString ? JSON.parse(listPageIdString) : [];
                      const index = listPageId.indexOf(pageId);
                      if (index !== -1) listPageId.splice(index, 1);
                      localStorage.setItem('updateSettingList', JSON.stringify(listPageId));

                      app.$store.commit('page/REMOVE_SETTING_CHANGED_LIST', pageId);
                      $publishButton.removeClass('publishing');
                      onSaveSuccess(false);
                    } else {
                      clearTimeout(socketData.timeout);
                      socketData.timeout = setTimeout(() => {
                        window._webSocket.offmessage('page_publish_processing');
                        HELPER.showNotify('Data update Failed, please try again later.', 'error');
                        onComplete(false);
                        $publishButton.removeClass('publishing');
                      }, socketData.TIMEOUT);

                      let progressInterval = -1;

                      // Start socket progress
                      {
                        let percent = 0;
                        if (percent < 0) {
                          percent = 0;
                        }
                        const percentTo = Math.round(100 / (jsonData.totalSteps || 4));
                        progressInterval = setInterval(() => {
                          percent++;
                          $progressBar.width(percent + '%');

                          if (percent > percentTo) {
                            clearInterval(progressInterval);
                          }
                        }, socketData.INTERVAL);
                        // $progressMessage.text("Saving....");
                      }

                      window._webSocket.onmessage('page_publish_processing', (data) => {
                        if (data.status == 'error') {
                          clearTimeout(socketData.timeout);
                          clearInterval(progressInterval);
                          window._webSocket.offmessage('page_publish_processing');
                          // backend trả key `messsage` (3 chữ s)
                          HELPER.showNotify(
                            data.messsage || data.message || 'Data update Failed, please try again later.',
                            'error',
                          );
                          onComplete(false);
                          $publishButton.removeClass('publishing');
                          return;
                        }

                        const step = data.currentStep;
                        const total = data.totalSteps;
                        socketData.percentage = Math.round((100 * step) / total);
                        clearInterval(progressInterval);
                        // $progressMessage.text(data.message);
                        if (socketData.percentage >= 100) {
                          clearTimeout(socketData.timeout);
                          HELPER.showNotify('Data published Successfully.', 'success');
                          store.setValue('__isPublished', true);
                          app.$store.commit('app/UPDATE_PAGE_IS_PUBLISHED', true);

                          const pageInfo = store.getValue('__page');
                          const pageId = pageInfo.page.g_id;
                          const listPageIdString = localStorage.getItem('updateSettingList');
                          const listPageId = listPageIdString ? JSON.parse(listPageIdString) : [];
                          const index = listPageId.indexOf(pageId);
                          if (index !== -1) listPageId.splice(index, 1);
                          localStorage.setItem('updateSettingList', JSON.stringify(listPageId));

                          app.$store.commit('page/REMOVE_SETTING_CHANGED_LIST', pageId);
                          // $modalProgress.removeClass("show");
                          $publishButton.removeClass('publishing');
                          onSaveSuccess(true);
                          window._webSocket.offmessage('page_publish_processing');
                        } else {
                          const percentTo = Math.round((100 * (step + 1)) / total) - 1;
                          let percent = socketData.percentage;
                          if (percent < 0) {
                            percent = 0;
                          }
                          progressInterval = setInterval(() => {
                            percent++;
                            $progressBar.width(percent + '%');
                            if (percent > percentTo) {
                              clearInterval(progressInterval);
                            }
                          }, socketData.INTERVAL);
                        }
                      });
                    }
                  } else {
                    onSaveSuccess(false);
                  }
                }
              })
              .catch(({ xhr, status, error }) => {
                onError(xhr, status, error);
              });
          }

          ajaxSaveToServer();
          _this.isSendDone = false;
        } else {
          HELPER.showNotify('There are some errors occurred please try again.', 'error');
        }
      }, 100);

      //move SnippetUsage to localStorage
      setTimeout(function () {
        if ($gfLeftSideBar.data('gfleftsidebar') != undefined) {
          $gfLeftSideBar.data('gfleftsidebar').saveSnippetUsageLocalStorage();
        }
      }, 100);
      return false;
    };

    this.sendUsageToServer = function () {
      setTimeout(function () {
        if ($gfLeftSideBar.data('gfleftsidebar') == undefined) {
          return;
        }

        const snippetUsage = $gfLeftSideBar.data('gfleftsidebar').getSnippetUsageLocalStorage();
        //count
        let countUsage = 0;
        for (const key in snippetUsage) {
          countUsage += snippetUsage[key].usage;
        }
        if (countUsage < 20) {
          return;
        }

        const shop = gfFrameData.getShopDomain();
        const data = {
          snippets: snippetUsage,
        };

        POST(api.saveSnippetUsage(shop).url, data).then((res) => {
          $gfLeftSideBar.data('gfleftsidebar').resetSnippetUsage();
        });
      }, 100);
    };

    this.searchProductInList = function (productId) {
      return HELPER.searchProductInList(productId);
    };

    this.initProductModules = function (callback) {
      if ($element.find('.module-wrap[data-label="Product"]').length > 0) {
        let ids = [];
        const foundAuto = 0;
        const pageType = gfFrameData.getPageType();

        // Preload product ids
        $element
          .find('.module-wrap[data-label="Product"], .module-wrap[data-label="Related Products"]')
          .each(function () {
            if ((mode = 'dev' && pageType != 'template-product')) {
              $(this).removeAttr('data-status');
            }
            const id =
              jQuery(this).children('.module').attr('data-pid') != undefined
                ? jQuery(this).children('.module').attr('data-pid')
                : '';
            if (id != 'auto' && id != '') {
              ids.push(id);
            }
          });
        ids = [...new Set(ids)].join(',');
        const req = api.getProductsByIds();
        GET(req.url, `ids=${ids}&latest=true`)
          .then((res) => {
            const jsonData = res.data;
            window._isFirstLoad = false;
            const latestProduct = jsonData.latestProduct;
            if (latestProduct && latestProduct.id) {
              window._productLatest = latestProduct;
              app.$store.commit(`app/UPDATE_LATEST_PRODUCT_IN_SHOPIFY`, latestProduct);
            }
            if (!jQuery.isEmptyObject(jsonData.products)) {
              window._productArray = window._productArray.concat(jsonData.products);
              HELPER.handleProductNotFound(false);
            } else {
              HELPER.handleProductNotFound(true);
            }
            const $_products = $element.find('.module-wrap[data-label="Product"]');
            var loadDQ = function ($_products, i, length) {
              if (length <= i || length == undefined) {
                if (callback) {
                  return callback();
                } else {
                  return false;
                }
              }
              const $module = jQuery($_products[i]);
              if ($module.data('gfmodule') != undefined) {
                $module.data('gfmodule').refresh();
              } else {
                // $module.gfModule();
                atom.Init($module);
              }
              setTimeout(function () {
                i++;
                return loadDQ($_products, i, length);
              }, 200);
            };

            const length = $_products.length;
            loadDQ($_products, 0, length);
          })
          .catch((err) => {
            console.log(err);
            if (callback) {
              return callback();
            }
          });
      } else {
        window._isFirstLoad = false;
        callback();
      }
    };

    this.initLatestProduct = function (callback) {
      const autoProductId = 'auto';
      const productData = HELPER.searchProductInList(autoProductId);
      if (Object.keys(productData).length) {
        if (productData.id == autoProductId) {
          productData.id = productData.real_id;
          delete productData.real_id;
        }
        callback(productData);
      } else {
        const res = api.getProduct();
        const data = {
          productId: autoProductId,
        };
        GET(res.url, data)
          .then((res) => {
            const jsonData = res.data;
            callback(jsonData.product);
          })
          .catch((err) => {
            console.log(err);
            callback(err);
          });
      }
    };

    this.initProductListModules = function (callback) {
      //  product list module
      if ($element.find('.module-wrap[data-label="Product List"]').length > 0) {
        const ids = [];
        $element.find('.module-wrap[data-label="Product List"]').each(function () {
          const $module = jQuery(this).children('.module');
          const list = {
            cid: $module.attr('data-cid'),
            limit: $module.attr('data-limit'),
          };
          ids.push(list);
        });
        const uniqueIds = Array.from(new Set(ids.map((item) => JSON.stringify(item)))).map((item) => JSON.parse(item));
        const queryIds = uniqueIds.slice(0, 3); // optimize for performance just query 3 first product list
        const data = {
          cids: JSON.stringify(queryIds),
        };

        app.$store.commit('page/SET_FRAME_LOADING_MESSAGE', 'Loading Product Data');
        // app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', true);

        $element.find('.module-wrap[data-label="Product List"]').fadeOut();

        const beforeSend = (xhr) => {
          xhr.setRequestHeader('X-CSRF-Token', jQuery('meta[name="csrf-token"]').attr('content'));
        };
        GET(api.getProductsByCollectionIds().url, data, undefined, undefined, undefined, beforeSend)
          .then((res) => {
            const jsonData = res.data;
            window._isFirstLoadList = false;

            if (!jQuery.isEmptyObject(jsonData.products)) {
              window._productListArray = jsonData.products;

              // add to one list
              for (let i = 0; i < jsonData.products.length; i++) {
                const productListData = jsonData.products[i];
                const collection = {
                  id: jsonData.products[i].cid,
                  published_at: jsonData.products[i].publishedAt,
                };
                HELPER.updateCollectionInList(collection);
                for (let j = 0; j < productListData.list.length; j++) {
                  const productData = productListData.list[j];

                  // check the nay de uu tien khi load san pham no update variant.available
                  const data = HELPER.searchProductInList(productData.id);
                  if (jQuery.isEmptyObject(data)) {
                    HELPER.updateProductInList(productData);
                  }
                }
              }
            }

            const $_products = $element.find('.module-wrap[data-label="Product List"]');
            var loadDQ = function ($_products, i, length) {
              if (length <= i || length == undefined) {
                return false;
              }
              const $module = jQuery($_products[i]);
              $module.fadeIn();

              if ($module.data('gfmodule') != undefined) {
                $module.data('gfmodule').refresh();
              } else {
                // $module.gfModule();
                atom.Init($module);
              }

              setTimeout(function () {
                i++;
                return loadDQ($_products, i, length);
              }, 300);
            };

            const length = $_products.length;
            loadDQ($_products, 0, length);

            app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);

            if (callback) {
              return callback();
            }
          })
          .catch((err) => {
            gfFrameData.hideLoading();
            const message = (err.xhr && err.xhr.responseJSON && err.xhr.responseJSON.message) || '';
            if (message && message === 'collectionNotFound') {
              HELPER.showNotify('Collection not found.', 'error');
            }
            console.error(err);
            if (callback) {
              return callback();
            }
          });
      } else {
        window._isFirstLoadList = false;
        callback();
      }
      return false;
    };

    this.initRelatedProducts = function (callback) {
      const $_products = $gryffBody.find('.module-wrap[data-label="Related Products"]');
      const pageType = gfFrameData.getPageType();

      if ((mode = 'dev' && pageType != 'template-product')) {
        $_products.removeAttr('data-status');
      }

      var loadDQ = function ($_products, i, length) {
        if (length <= i || length == undefined) {
          if (callback) {
            return callback();
          } else {
            return false;
          }
        }
        const $module = jQuery($_products[i]);
        $module.fadeIn();

        if ($module.data('gfmodule') != undefined) {
          $module.data('gfmodule').refresh();
        } else {
          // $module.gfModule();
          atom.Init($module);
        }
        setTimeout(function () {
          i++;
          return loadDQ($_products, i, length);
        }, 200);
      };

      const length = $_products.length;
      loadDQ($_products, 0, length);

      return false;
    };

    this.initCollections = function (callback) {
      callback();
      return;
      //remove because at moment now, collection no need real data
      // update stuffs
      /* var shop = gfFrameData.getShopDomain();
            var data = {
                shop: shop,
                limit: 50
            }
            // GET('api/collection/getCollections.html', data)
            //   .then(res => {
            //     const jsonData = res.data;
            //     if (!jQuery.isEmptyObject(jsonData)) {
            //         var _collections = jsonData['collections'];
            //         // COLLECTION 2019
            //         for (var i = 0; i < _collections.length; i++) {
            //             HELPER.updateCollectionInList(_collections[i])
            //         }

            //         if (_collections.length > 0) {
            //             callback(_collections[0])
            //         } else {
            //             callback()
            //         }
            //     }
            //   })
            //   .catch(err => {
            //     callback()
            //   });
          }; */
    };

    /**
     *
     * @param {object} $divContainer
     * @param {boolean} doExport Variable to check whenver export template, publish page
     */
    this.getEditorContent = function ($divContainer, doExport = false) {
      // --------------------------------------------------------------------
      let html = '';
      let bkHtml = '';
      let style = '';
      let script = '';
      let libs = [];
      let fonts = [];

      if (checkKeyValid('trackingError')) {
        window.trackingError = [];
        if (!$gryffEditor || !$gryffEditor.length) {
          window.trackingError.push('gryffEditor');
        }
      }

      if (!$divContainer) {
        $divContainer = $gryffEditor;
      }

      const $gryffEditorContent = $gfFrame.contents().find('.gryffeditor');
      if (!$divContainer) {
        $divContainer = $gryffEditorContent.first();
        this.trackGryffEditorLength($gryffEditorContent);
      }

      $divContainer.children('.gf_row, .module-wrap, .element-wrap').each(function () {
        const $that = jQuery(this);
        let data;

        if ($that.attr('data-label') != 'Popup') {
          if ($that.data('gfrow') != undefined) {
            data = $that.data('gfrow').exportMe();
          } else if ($that.data('gfmodule') != undefined) {
            data = $that.data('gfmodule').exportMe();
          } else if ($that.data('gfelement') != undefined) {
            data = $that.data('gfelement').exportMe();
          }
          if (data) {
            html += data.html;
            html += '<!--gfsplit-->';
            bkHtml += data.bkHtml;
            style += data.style;
            script += data.script;
            libs = libs.concat(data.libs);
            fonts = fonts.concat(data.fonts);
          }
        }
      });

      // Popup only
      $gryffBody.find('.module-wrap[data-label="Popup"]').each(function () {
        const $that = jQuery(this);

        let data;
        if ($that.data('gfmodule') != undefined) {
          data = $that.data('gfmodule').exportMe();
        }
        if (data) {
          html += data.html;
          html += '<!--gfsplit-->';
          bkHtml += data.bkHtml;
          style += data.style;
          script += data.script;
          libs = libs.concat(data.libs);
          fonts = fonts.concat(data.fonts);
        }
      });

      // enable script tags
      html = html.replace(/scri-pt/g, 'script');
      script = script.replace(/scri-pt/g, 'script');
      // correct style mistakes, some times there are strange *undefined* in style scss
      style = style.replace(/undefined/g, '');

      // GET FONT LIST
      const fontRegex = /font-family.*?;/g;
      const fontsInStyle = style.match(fontRegex);
      if (fontsInStyle && fontsInStyle.length) {
        const fontInStyleLength = fontsInStyle.length;
        for (let i = 0; i < fontInStyleLength; i++) {
          const fontName = HELPER.getFontNameFromString(fontsInStyle[i]);
          // also check these excludes in getFonts function
          if (jQuery.inArray(fontName, fonts) === -1 && jQuery.inArray(fontName, window._themeFonts) === -1) {
            fonts.push(fontName);
          }
        }
      }

      $gryffEditor.find('font').each(function () {
        const styleAttr = jQuery(this).attr('style');
        if (styleAttr && styleAttr.match(fontRegex)) {
          const fontsInStyle = styleAttr.match(fontRegex)[0];
          const fontName = HELPER.getFontNameFromString(fontsInStyle);

          // also check these excludes in getFonts function
          if (jQuery.inArray(fontName, fonts) === -1 && jQuery.inArray(fontName, window._themeFonts) === -1) {
            fonts.push(fontName);
          }
        }
      });

      // TODO: optimise this
      $gryffBody.find('.module-wrap[data-label="Popup"] font').each(function () {
        const styleAttr = jQuery(this).attr('style');
        if (styleAttr && styleAttr.match(fontRegex)) {
          const fontsInStyle = styleAttr.match(fontRegex)[0];
          const fontName = HELPER.getFontNameFromString(fontsInStyle);

          // also check these excludes in getFonts function
          if (jQuery.inArray(fontName, fonts) === -1 && jQuery.inArray(fontName, window._themeFonts) === -1) {
            fonts.push(fontName);
          }
        }
      });

      // LAZYLOADING2019
      // Apply lazyloading
      // Check if do not export template -> apply lazyloading
      if (!doExport) {
        html = HELPER.applyLazyLoad(html);
      }

      // Add schema
      const gType = gfFrameData.getPageType();
      let schema = '';
      const pageId = gfFrameData.getPageId();

      switch (gType) {
        case 'template-product':
          var req = api.updateProductSchema();
          var disableSchema = window.gfDisableSchema;
          if (disableSchema == undefined) {
            disableSchema = window.__gfDisableSchema;
          }

          if (disableSchema != window.__gfDisableSchema && window.__gfDisableSchema != undefined) {
            const beforeSend = (xhr) => {
              xhr.setRequestHeader('X-CSRF-Token', jQuery('meta[name="csrf-token"]').attr('content'));
            };
            const data = {
              pageId: pageId,
              value: disableSchema.toString(),
            };
            PUT(api.updateProductSchema().url, data, undefined, undefined, undefined, beforeSend).then((res) => {
              window.__gfDisableSchema = disableSchema;
            });
          }

          if (!disableSchema) {
            // check review party added
            const reviewsArr = [
              'Ali Reviews',
              'Loox Product Page + Stars',
              'Loox (Stars)',
              'Loox (Widgets)',
              'Judge.me Reviews',
              'Product Reviews',
              'Growave',
              'Yotpo - Product & Collection Page',
              'Ryviu: Product Review App',
              'Stamped.io - Product & Collection Page',
              'Rivyo Reviews',
              'Opinew - Product & Collection Pages',
            ];
            let currentParty = '';
            let assignVar = ``;
            let countData = ``;
            let aggregateRating = ``;

            const shopifyPRCountData = `{%- comment -%}
                          For Shopify Product Reviews
                      {%- endcomment -%}
                      {%- if product.metafields.spr.reviews -%}
                          {%- assign product_review_array="reviewCount,ratingValue"|split:',' -%}
                          {%- capture review_data -%}{{product.metafields.spr.reviews}}{%- endcapture -%}
                          {%- assign array_builder="" -%}

                          {%- for review_data_item in product_review_array -%}
                              {%- capture new_var -%}"{{ review_data_item }}"{%- endcapture -%}
                              {%- assign review_data1=review_data|split:new_var -%}
                              {%- assign review_data2=review_data1[1]|split:":" -%}
                              {%- assign review_data3=review_data2[1]|split:'"' -%}
                              {%- assign review_data_value=review_data3[1]|plus:1|minus:1 -%}
                              {%- assign array_builder=array_builder|append:review_data_value|append:'_' -%}
                          {%- endfor -%}

                          {%- assign review_data_array=array_builder|split:'_' -%}
                          {%- assign g_review_count=review_data_array[0] -%}
                          {%- assign g_rating_value=review_data_array[1] -%}
                      {%- endif -%}`;

            const judgeCountData = `{%- comment -%}
                          For Judge.me Reviews
                      {%- endcomment -%}
                      {%- if product.metafields.judgeme.badge -%}
                          {%- assign product_review_array="data-number-of-reviews,data-average-rating"|split:',' -%}
                          {%- capture review_data -%}{{product.metafields.judgeme.badge}}{%- endcapture -%}
                          {%- assign array_builder="" -%}

                          {%- for review_data_item in product_review_array -%}
                              {%- assign review_data1=review_data|split:review_data_item -%}
                              {%- assign review_data2=review_data1[1]|split:"=" -%}
                              {%- assign review_data3=review_data2[1]|split:"'" -%}
                              {%- assign review_data_value=review_data3[1]|plus:1|minus:1 -%}
                              {%- assign array_builder=array_builder|append:review_data_value|append:'_' -%}
                          {%- endfor -%}

                          {%- assign review_data_array=array_builder|split:'_' -%}
                          {%- assign g_review_count=review_data_array[0] -%}
                          {%- assign g_rating_value=review_data_array[1] -%}
                      {%- endif -%}`;

            const looxCountData = `{%- comment -%}
                          For Loox Product Page + Stars
                      {%- endcomment -%}
                      {%- if product.metafields.loox.num_reviews -%}
                          {%- assign g_review_count=product.metafields.loox.num_reviews -%}
                          {%- assign g_rating_value=product.metafields.loox.avg_rating -%}
                      {%- endif -%}`;

            var opinewCountData = `{%- comment -%}
                          Opinew Product Reviews
                      {%- endcomment -%}
                      {%- if product.metafields.opinew_metafields.reviews_count and product.metafields.opinew_metafields.reviews_count != "0" -%}
                          {%- assign g_review_count=product.metafields.opinew_metafields.reviews_count -%}
                          {%- assign g_rating_value=product.metafields.opinew_metafields.reviews_average -%}
                      {%- endif -%}`;

            const growaveCountData = `{%- comment -%}For Growave{%- endcomment -%}
                      {%- assign ssw_unite_reviews = 0 -%}
                      {%- if shop.metafields.ssw['unite_reviews'] -%}
                          {%- assign ssw_unite_reviews = shop.metafields.ssw['unite_reviews'] -%}
                      {%- endif -%}
                      {%- assign ssw_rate_data_key = 'review' -%}
                      {%- if ssw_unite_reviews == 1 -%}
                          {%- if shop.metafields.ssw['unite_product_ids'] -%}
                              {%- assign ssw_unite_product_ids = shop.metafields.ssw['unite_product_ids'] | split: ',' -%}
                              {%- assign unite_product_id = product.id | downcase -%}
                              {%- if ssw_unite_product_ids contains unite_product_id -%}
                                  {%- assign ssw_rate_data_key = 'unite_review' -%}
                              {%- endif -%}
                          {%- endif -%}
                      {%- endif -%}
                      {%- if product.metafields.ssw[ssw_rate_data_key] -%}
                          {%- assign g_review_count = product.metafields.ssw[ssw_rate_data_key].count | plus: 0 -%}
                          {%- assign g_rating_value = product.metafields.ssw[ssw_rate_data_key].avg | plus: 0 -%}
                          {%- assign ssw_product_id = product.id -%}
                          {%- if product.metafields.ssw[ssw_rate_data_key].product_id -%}
                              {%- assign ssw_product_id = product.metafields.ssw[ssw_rate_data_key].product_id | plus: 0 -%}
                          {%- endif -%}
                          {%- if ssw_product_id != product.id -%}
                              {%- assign g_review_count  = 0 -%}
                              {%- assign g_rating_value = 0 -%}
                          {%- endif -%}
                      {%- endif -%}`;

            const yotpoCountData = `{%- comment -%}
                          For Yotpo
                      {%- endcomment -%}
                      {% if product.metafields.yotpo.reviews_count and product.metafields.yotpo.reviews_count != "0" %}
                          {%- assign g_review_count=product.metafields.yotpo.reviews_count -%}
                          {%- assign g_rating_value=product.metafields.yotpo.reviews_average -%}
                      {% endif %}
                      `;
            const rivyoCountData = `{%- comment -%}
                          Rivyo Reviews
                      {%- endcomment -%}

                      {%- if product.metafields.product_schema['th_ratingCount'] > 0 -%}
                          {%- assign g_review_count=product.metafields.product_schema['th_ratingCount'] -%}
                          {%- assign g_rating_value=product.metafields.product_schema['th_ratingValue'] -%}
                      {%- endif -%}`;

            const stampedCountData = `{%- comment -%}
                          For Stamped.io - Product & Collection Page
                      {%- endcomment -%}
                      {%- if product.metafields.stamped.reviews_count and product.metafields.stamped.reviews_count != "0" -%}
                          {%- assign g_review_count = product.metafields.stamped.reviews_count -%}
                          {%- assign g_rating_value = product.metafields.stamped.reviews_average | round:2 -%}
                      {%- endif -%}`;

            const ryviuCountData = `{%- comment -%}
                          For Ryviu
                      {%- endcomment -%}
                      {% assign ryviu = product.metafields.ryviu %}
                      {% if ryviu %}
                          {%- assign ryviuAggregateRating = ryviu.product_reviews_info | split: ";" -%}
                          {%- assign g_rating_value = ryviuAggregateRating[1] | plus: 0 -%}
                          {%- assign g_review_count = ryviuAggregateRating[0] | plus: 0 -%}
                      {% endif %}`;

            var opinewCountData = `{%- comment -%}
                          Opinew Product Reviews
                      {%- endcomment -%}
                      {%- if product.metafields.opinew_metafields.reviews_count and product.metafields.opinew_metafields.reviews_count != "0" -%}
                          {%- assign g_review_count=product.metafields.opinew_metafields.reviews_count -%}
                          {%- assign g_rating_value=product.metafields.opinew_metafields.reviews_average -%}
                      {%- endif -%}`;

            for (let i = 0; i < reviewsArr.length; i++) {
              if ($gryffBody.find('.module-wrap[data-label="' + reviewsArr[i] + '"]').length) {
                currentParty = reviewsArr[i];
                break;
              }
            }

            if (!currentParty) {
              //no party
            } else {
              assignVar = `{%- assign g_review_count = 0 -%} {%- assign g_rating_value = 0 -%}`;
              aggregateRating = `
                              {%- if g_review_count != 0 -%}
                              "aggregateRating": {
                                  "@type": "AggregateRating",
                                  "ratingValue": "{{ g_rating_value }}",
                                  "reviewCount": "{{ g_review_count }}"
                              },
                              {%- endif -%}`;
              switch (currentParty) {
                case 'Ali Reviews':
                  //special for alireviews
                  assignVar = ``;
                  countData = ``;
                  aggregateRating = `{%- if product.metafields.alireviews.seo_rating_review_key_script -%} {{ product.metafields.alireviews.seo_rating_review_key_script }} {%- endif -%}`;
                  break;
                case 'Loox Product Page + Stars':
                case 'Loox (Stars)':
                case 'Loox (Widgets)':
                  countData = looxCountData;
                  break;
                case 'Judge.me Reviews':
                  countData = judgeCountData;
                  break;
                case 'Product Reviews':
                  countData = shopifyPRCountData;
                  break;
                case 'Growave':
                  countData = growaveCountData;
                  break;
                case 'Yotpo - Product & Collection Page':
                  countData = yotpoCountData;
                  break;
                case 'Rivyo Reviews':
                  countData = rivyoCountData;
                  break;
                case 'Stamped.io - Product & Collection Page':
                  countData = stampedCountData;
                  break;
                case 'Ryviu: Product Review App':
                  countData = ryviuCountData;
                  break;
                case 'Opinew - Product & Collection Pages':
                  countData = opinewCountData;
                  break;
                default:
                  break;
              }
            }
            const customSchemaOffersValue = `"priceValidUntil": "{{'now' | date: '%s' | plus: days_price_valid_until | date: '%Y-%m-%d'}}",`;
            schema = `<script type="application/ld+json">
                          ${assignVar}
                          ${countData}
                          {%- assign cv_schema = product.selected_or_first_available_variant -%}
                          {
                              "@context":"http://schema.org/",
                              "@type":"Product",
                              ${aggregateRating}
                              "name":{{product.title|json}},
                              "url":{{shop.url|append:product.url|json}},
                              {%- if product.featured_image -%}
                                  {%- assign image_size=product.featured_image.width|append:'x' -%}
                                  "image":[{{product.featured_image.src|img_url:image_size|prepend:"https:"|json}}],
                              {%- endif -%}
                              "description":{{product.description|strip_html|json}},
                              {%- if cv_schema.sku!=blank -%}
                                  "sku":{{cv_schema.sku|json}},
                              {%- endif -%}
                              "brand":{"@type": "${
                                checkKeyValid('customSchemaBrandType') ? 'Brand' : 'Thing'
                              }","name":{{product.vendor|json}}},
                              "offers":{
                                  "@type":"Offer",
                                  "availability":"http://schema.org/{% if cv_schema.available %}InStock{% else %}OutOfStock{% endif %}",
                                  "price":{{cv_schema.price|divided_by:100.00|json}},
                                  "priceCurrency":{{cart.currency.iso_code|json}},
                                  ${checkKeyValid('customSchemaOffersValue') ? customSchemaOffersValue : ''}
                                  "url":{{shop.url|append:cv_schema.url|json}}
                              }
                          }
                      </script>`;

            schema = `<div style="display:none!important">{% if shop.metafields.gpGlobalConfigs.enableProductSchema == "true" or shop.metafields.gpGlobalConfigs.enableProductSchema == blank %}${HELPER.compressHTML(
              schema,
            )}{% endif %}</div>`;
          }
          break;
        case 'template-article':
        case 'template-collection':
          break;
        case 'template-index':
        case 'template-page':
        default:
          break;
      }
      // Backup lại biến product của trang để tránh lỗi sinh ra schema sai
      if (!doExport) {
        if (gType == 'template-product') {
          html = `{% assign gem_product_bak = product %}${html}{% if gem_product_bak %}{% assign product = gem_product_bak %}{% endif %}`;
        }
      }

      html += schema;

      //add testing code để lib (frontend) có thể có dữ liệu để test. Sau khi test done thì xóa đi
      let gemKeyValidHtml = '';
      const keyList = [];
      if (checkKeyValid('bestWayAddToCart')) {
        keyList.push('bestWayAddToCart');
      }
      if (checkKeyValid('clickAddToCart')) {
        keyList.push('clickAddToCart');
      }
      if (checkKeyValid('hotfixMarketPlace')) {
        keyList.push('hotfixMarketPlace');
      }

      if (keyList.length > 0) {
        let registerHtml = '';
        keyList.forEach((key) => {
          registerHtml += `window.__gemStoreData.gemKeyValid.${key} = 1;`;
        });

        gemKeyValidHtml += `<script>
              window.__gemStoreData = {};
              window.__gemStoreData.gemKeyValid = {};
              ${registerHtml}
              </script>`;
        html += HELPER.compressHTML(gemKeyValidHtml);
      }

      if (checkKeyValid('trackingError')) {
        if (!html || !bkHtml) {
          window.trackingError.push('emptyPage');
        }
      }

      const pageFonts = app.$store.getters['font/pageFonts'];

      fonts = arrayFilter(
        pageFonts,
        (font) => !font.custom,
        (font) => font.styleName,
      );
      const installedFonts = arrayFilter(pageFonts, (font) => font.isInstalled);

      const installedFontFacesString = insertInstalledFontsWhenSavingPage(installedFonts);
      style = installedFontFacesString + style;

      return {
        html: html,
        bkHtml: bkHtml,
        style: style,
        script: script,
        libs: libs,
        fonts: fonts,
      };
    };

    this.trackGryffEditorLength = function ($gryffEditorContent) {
      if (checkKeyValid('trackGryffEditorLength')) {
        if ($gryffEditorContent.length > 1) {
          const pageInfoData = app.$store.getters['app/pageInfoData'];
          const templateId = pageInfoData.g_id;
          window.trackingError.push(`${templateId} - multiple gryffeditor`);
        }
      }
    };

    this.isDragging = function () {
      return _isDragging;
    };

    this.setDragging = function (bool) {
      if (bool) {
        $element.addClass('dragging');
      } else {
        $element.removeClass('dragging');
      }
      return (_isDragging = bool);
    };

    this.addEditorContent = async function (html, bkHtml, $newPlace, callback, options) {
      let replaceIds = true;
      let isInserting = undefined;
      let isCreatedFromTemplate = undefined;

      if (checkKeyValid('noScriptFromLiquid')) {
        html = HELPER.noScriptFromLiquid(html);
      }

      // replace id before insert
      if (options == undefined) {
        replaceIds = true;
      }

      if (typeof options == 'boolean') {
        replaceIds = options;
      } else if (typeof options == 'object') {
        if (typeof options.replaceIds == 'boolean') {
          replaceIds = options.replaceIds;
        }
        isCreatedFromTemplate = options.isCreatedFromTemplate;
        isInserting = isCreatedFromTemplate ? true : options.isInserting;
      }

      let $wrapper,
        $libs,
        stylesList = [];
      if (isCreatedFromTemplate) {
        stylesList = app.$store.getters['editor/GET_ALL_STYLES'];
      } else {
        $wrapper = jQuery(bkHtml);
        $libs = $wrapper.find('script.libs');

        if (replaceIds) {
          const rData = HELPER.replaceIds(html, bkHtml);
          html = rData.html;
          bkHtml = rData.bkHtml;
        }
        const $styles = $wrapper.find('style.style');
        const stylesLength = $styles.length;
        for (let i = 0; i < stylesLength; i++) {
          const styleHtml = $styles.eq(i).html();
          stylesList.push(styleHtml);
        }
      }
      const style = stylesList.join('');

      // style = HELPER.formatCSS(style);

      /* -- start custom fonts */
      const fonts = [];
      // GET FONT LIST
      const fontRegex = /font-family.*?;/g;
      var fontsInStyle = style.match(fontRegex);
      const addFonts = [];
      if (fontsInStyle && fontsInStyle.length) {
        const length = fontsInStyle.length;
        for (let i = 0; i < length; i++) {
          var fontName = HELPER.getFontNameFromString(fontsInStyle[i]);
          if (isInserting) {
            addFonts.push({
              googleName: fontName,
              styleName: fontName,
              isActive: true,
              custom: true,
            });
          }
          // also check these excludes in getFonts function
          else if (jQuery.inArray(fontName, fonts) === -1 && jQuery.inArray(fontName, window._themeFonts) === -1) {
            fonts.push(fontName);
          }
        }
      }
      const $font = $gryffEditor.find('font');
      const $fontLength = $font.length;
      for (let i = 0; i < $fontLength; i++) {
        const styleAttr = jQuery($font[i]).attr('style');
        if (styleAttr && styleAttr.match(fontRegex)) {
          var fontsInStyle = styleAttr.match(fontRegex)[0];
          var fontName = HELPER.getFontNameFromString(fontsInStyle);

          if (isInserting) {
            addFonts.push({
              googleName: fontName,
              styleName: fontName,
              isActive: true,
              custom: true,
            });
          }
          // also check these excludes in getFonts function
          else if (jQuery.inArray(fontName, fonts) === -1 && jQuery.inArray(fontName, window._themeFonts) === -1) {
            fonts.push(fontName);
          }
        }
      }

      const $popupFont = $gryffBody.find('font', '.module-wrap[data-label="Popup"]');
      const $popupFontLength = $popupFont.length;
      for (let i = 0; i < $popupFontLength; i++) {
        const styleAttr = jQuery($popupFont[i]).attr('style');
        if (styleAttr && styleAttr.match(fontRegex)) {
          var fontsInStyle = styleAttr.match(fontRegex)[0];
          var fontName = HELPER.getFontNameFromString(fontsInStyle);

          if (isInserting) {
            addFonts.push({
              googleName: fontName,
              styleName: fontName,
              isActive: true,
              custom: true,
            });
          }
          // also check these excludes in getFonts function
          else if (jQuery.inArray(fontName, fonts) === -1 && jQuery.inArray(fontName, window._themeFonts) === -1) {
            fonts.push(fontName);
          }
        }
      }

      if (isCreatedFromTemplate) {
        return;
      }
      /* -- end custom fonts */

      const $loading = jQuery('<div></div>');
      const libs = [];
      $wrapper.find('script.libs').each(function () {
        try {
          if (jQuery(this).html().trim() != '') {
            const libJson = jQuery.parseJSON(jQuery(this).html());
            for (let j = 0; j < libJson['libs'].length; j++) {
              if (jQuery.inArray(libJson['libs'][j], window._pageLibs) === -1) {
                libs.push(libJson['libs'][j]);
              }
            }
          }
        } catch (err) {
          console.log(err.message);
        }
      });

      if (libs.length > 0) {
        HELPER.getLibs({
          urls: libs,
          start: function () {
            if ($newPlace != undefined) {
              $newPlace.before($loading);
            } else {
              $gryffEditor.prepend($loading);
            }
          },
          done: async function () {
            for (let i = 0; i < libs.length; i++) {
              if (jQuery.inArray(libs[i], window._pageLibs) === -1) {
                window._pageLibs.push(libs[i]);
              }
            }
            const $_html = jQuery(html);
            const label = $_html.attr('data-label');
            if (label == 'Popup') {
              $_html.appendTo($gryffBody);
              var $html = $_html.parent();
            } else {
              $loading.after(html);
              var $html = $loading.parent();
              $loading.remove();
            }

            HELPER.addContentBk(bkHtml);

            // refresh elements
            const refreshElements = function () {
              const $children = $html.children('.element-wrap, .module-wrap, .gf_row');
              let $object = null;
              console.time('init child');
              const dothings = function ($object, timeout) {
                setTimeout(function () {
                  if ($object.hasClass('element-wrap')) {
                    // $object.gfElement();
                    atom.Init($object);
                  } else if ($object.hasClass('module-wrap')) {
                    // $object.gfModule();
                    atom.Init($object);
                  } else if ($object.hasClass('gf_row')) {
                    // $object.gfRow();
                    atom.Init($object);
                  }

                  // detect element or module change
                  const $itemContent = $object.closest('.item-content');
                  HELPER.detectContentChange($itemContent);
                }, timeout);
              };
              for (let i = 0; i < $children.length; i++) {
                $object = $children.eq(i);
                // dothings($object, i * 500);
                dothings($object, i * 10);
              }
              console.timeEnd('init child');
              callback(html);
            };

            // check product data
            const productId = 'auto';
            var productData = HELPER.searchProductInList(productId);
            if (!jQuery.isEmptyObject(productData)) {
              refreshElements();
            } else {
              if ($html.find('[data-product]').length > 0) {
                // load ajax
                const shop = gfFrameData.getShopDomain();

                const data = {
                  shop: shop,
                  productId: productId,
                };

                app.$store.commit('page/SET_FRAME_LOADING_MESSAGE', 'Loading Product');
                app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', true);

                try {
                  const res = await GET(api.getProducts().url, data);
                  const jsonData = res.data;
                  gfFrameData.hideLoading();
                  var productData = jsonData.product;
                  productData.real_id = productData.id;
                  productData.id = 'auto';

                  HELPER.updateProductInList(productData);

                  refreshElements();
                  app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);
                } catch (error) {
                  app.$store.commit('page/SET_LOADING_CONTENT_EDITOR', false);
                  HELPER.showNotify('There are some errors occurred please try again. Error: 100', 'error');
                }
              } else {
                refreshElements();
              }
            }
          },
          block: function () {
            /**
             * trường hợp bị cookieyes chặn
             * Vẫn done như bình thường và gắn cờ bị block js
             */
            for (let i = 0; i < libs.length; i++) {
              if (jQuery.inArray(libs[i], window._pageLibsBlocked) === -1) {
                window._pageLibsBlocked.push(libs[i]);
              }
            }
            this.done();
          },
        });
      } else {
        const $_html = jQuery(html);
        const label = $_html.attr('data-label');
        if (label == 'Popup') {
          $_html.appendTo($gryffBody);
          var $html = $_html.parent();
        } else {
          if ($newPlace != undefined) {
            $newPlace.before($loading);
          } else {
            $gryffEditor.prepend($loading);
          }

          $loading.after(html);
          var $html = $loading.parent();
          $loading.remove();
        }

        HELPER.addContentBk(bkHtml);

        if (checkKeyValid('newInsertFunction')) {
          console.time('init child');
          const promises = [];
          $html.children('.element-wrap, .module-wrap, .gf_row').each(function () {
            const $mer = jQuery(this);
            promises.push(
              new Promise(async (resolve) => {
                atom.Init($mer);
                // detect element or module change
                const $itemContent = $mer.closest('.item-content');
                await HELPER.newDetectContentChange($itemContent);
                resolve();
              }),
            );
          });
          await Promise.all(promises);
          console.timeEnd('init child');
        } else {
          console.time('init child');
          $html.children('.element-wrap, .module-wrap, .gf_row').each(function () {
            const $mer = jQuery(this);
            atom.Init($mer);
            // detect element or module change
            const $itemContent = $mer.closest('.item-content');
            HELPER.detectContentChange($itemContent);
          });
          console.timeEnd('init child');
        }
        callback(html);
      }
      return false;
    };

    this.hidePlaceHolders = function () {
      if (window.$gfVSPlaceHolders != undefined) {
        window.$gfVSPlaceHolders.removeClass('show active');
      }
    };

    this.updatePlaceHolders = function () {
      const bPl = '<div class="block-placeholder"></div>';
      const $elementFirst = $gryffEditor.children('div').eq(0);
      if ($elementFirst && !$elementFirst.hasClass('block-placeholder')) {
        $gryffEditor.prepend(bPl);
      }

      if (HELPER.isPopupOpened()) {
        const popupPermission =
          storeX.state.app?.planPermissions?.popupElement !== undefined
            ? storeX.state.app?.planPermissions?.popupElement
            : true;
        if (popupPermission) {
          window.$gfPlaceHolders = $gryffBody.find('[data-label="Popup"] .block-placeholder');
        } else {
          window.$gfPlaceHolders = [];
        }
      } else {
        window.$gfPlaceHolders = $gryffEditor.find('.block-placeholder');
      }

      window._placeHolders = [];
      let html = '';

      for (let i = 0; i < window.$gfPlaceHolders.length; i++) {
        const $placeHolder = window.$gfPlaceHolders.eq(i);

        const offset = $placeHolder.offset();
        let left = parseInt(offset.left);
        let top = parseInt(offset.top);
        let width = parseInt($placeHolder.css('width'));
        const height = 'auto';

        var marginTop = parseInt($placeHolder.css('marginTop'));
        if (marginTop < 0) {
          top += marginTop;
        }

        const $nextElement = $placeHolder.next();
        var marginTop = parseInt($nextElement.css('marginTop'));
        if (marginTop < 0) {
          top += marginTop;
        }

        if ($nextElement.hasClass('gf_add-content') && $placeHolder.prev().attr('class') == undefined) {
          var cssClass = 'blank-holder';
          left = left - 4;
          width = width + 1;
        } else {
          var cssClass = '';
        }

        // zoom placeholders
        width = width * window._zoomOut;
        top = top * window._zoomOut;
        left = left * window._zoomOut;

        const data = {
          left: left,
          top: top,
          width: width,
          id: i,
        };
        window._placeHolders.push(data);

        html +=
          '<div class="block-placeholder ' +
          cssClass +
          '" style="position: absolute; left: ' +
          left +
          'px; top: ' +
          top +
          'px; width: ' +
          width +
          'px;"></div>';
      }

      $gfVisualFrame.children('#visualContent').html(html);
      window.$gfVSPlaceHolders = $gfVisualFrame.find('.block-placeholder');

      return false;
    };

    this.getPreviewPageLink = function () {
      const previewHref = $divTopBar.find('#gf-preview').attr('href') || '';

      if (!previewHref) {
        const pageInfo = store.getValue('__page');
        if (pageInfo.page.preview_url) {
          return pageInfo.page.preview_url;
        }
      }
      return previewHref;
    };

    this.getViewPageLink = function () {
      const href = $divTopBar.find('#gf-view').attr('origin-href') || '';
      if (!href) {
        const pageInfo = store.getValue('__page');
        if (pageInfo.page.shopify_page_url) {
          return pageInfo.page.shopify_page_url;
        }
      }
      return href;
    };

    this.setPreviewPageLink = function (url) {
      $divTopBar.find('#gf-preview').attr('href', encodeURI(url));
      const pageInfo = store.getValue('__page');
      pageInfo.page.preview_url = url;
      store.setValue('__page', pageInfo);
      return false;
    };
    this.setViewPageLink = function (url) {
      // $divTopBar.find('#gf-view').attr('href', url);
      const pageInfo = store.getValue('__page');
      pageInfo.page.shopify_page_url = url;
      store.setValue('__page', pageInfo);
      return false;
    };

    this.blockStyleAnimationCarousel = function () {
      const styleBlock = `<style id="gf_block-carousel" type="text/css">.gf-carousel-loaded .gf-carousel-loading{display: none !important}</style>`;
      if ($gryffBody.find('#gf_block-carousel').length == 0) {
        $gryffBody.prepend(styleBlock);
      }
      return false;
    };

    // goi ham khoi tao init() ngay khi bat dau
    this.init();
  };

  jQuery.fn.gryffEditor = function (options) {
    return this.each(function () {
      if (undefined == jQuery(this).data('gryffeditor')) {
        const plugin = new jQuery.gryffEditor(this, options);
        jQuery(this).data('gryffeditor', plugin);
      }
    });
  };
})(jQuery);
